import { TemplateStage, TEMPLATE_TYPES, UserRole, QQ_TYPES, PlaybookTab as PlaybookTab$1, BobjectTypes } from '@bloobirds-it/types';
import React, { useContext, useState, useEffect, createContext, useCallback, useMemo, useRef } from 'react';
import { Select, Item, Text, Switch, MultiSelect, CheckItem, Tooltip, Icon, Label, Modal, ModalContent, ModalFooter, Button, ModalHeader, ModalTitle, ModalCloseIcon, createToast, Input, useHover, IconButton, Spinner, CircularBadge, Checkbox } from '@bloobirds-it/flamingo-ui';
import { useFormContext, useController, useForm, FormProvider } from 'react-hook-form';
import { usePlaybookSegmentation, useActiveUserSettings, useUserSearch, useMeetingLinksEnabled, useMessagingTemplate, useMessagingTemplates, useBaseSetEmailVariablesValues, useMinimizableModals, useQualifyingQuestions, useSnippetsEnabled, usePlaybook } from '@bloobirds-it/hooks';
import { toSentenceCase, formatDate, api, removeHtmlTags, partition, getLinkedInURL, EMAIL_MODE, baseUrls as baseUrls$2 } from '@bloobirds-it/utils';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { RichTextEditor, useRichTextEditorPlugins, EditorToolbar, EditorToolbarControlsSection, EditorToolbarFontStylesSection, EditorToolbarTextMarksSection, EditorToolbarListsSection, EditorToolbarSection, EditorToolbarMeetingLink, TemplateEditorToolbarFileAttachment, TemplateEditorToolbarImage, EditorToolbarTemplateVariable, FloatingTemplateVariable, deserialize } from '@bloobirds-it/rich-text-editor';
import { resetEditorChildren, insertElements, focusEditor } from '@udecode/plate';
import { AttachmentList, useAttachedFiles, NoResultsPage } from '@bloobirds-it/misc';
import useSWR from 'swr';
import { Editor } from 'slate';
import clsx from 'clsx';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$7 = ".handleTemplate-module_container__BB7uT {\n  height: 100%;\n  width: 100%;\n  padding: 24px 24px 0 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n.handleTemplate-module_header__VXLpc {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-bottom: 10px;\n}\n\n.handleTemplate-module_content__nJALI {\n  width: 100%;\n  height: -webkit-fill-available;\n}\n\n.handleTemplate-module_formHeader__zX7lx{\n  display: flex;\n  justify-content: space-between;\n  height: 24px;\n}\n\n.handleTemplate-module_headerText__IbAuH{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.handleTemplate-module_noPadding__hQaZ5 {\n  padding: 0;\n}\n.handleTemplate-module_templateNameContainer__vWfPq {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  padding: 8px 0;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--lightestBloobirds);\n  flex-shrink: 0;\n  transition: height 200ms;\n  gap: 2px;\n}\n\n.handleTemplate-module_input__I-rl3 {\n  position: relative;\n  width: 100%;\n}\n\n.handleTemplate-module_input__I-rl3 > input {\n  font-family: var(--fontFamily);\n  font-size: 12.5px;\n  line-height: normal;\n  padding: 0;\n}\n\n.handleTemplate-module_placeholder__8myEA {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  color: #c8c8c8;\n  font-family: var(--fontFamily);\n  font-size: 12.5px;\n  font-weight: 400;\n  line-height: normal;\n  padding: 2px 0;\n  opacity: 1;\n  pointer-events: none;\n}\n\n.handleTemplate-module_subjectContainer__DAVSQ {\n  display: flex;\n  position: relative;\n  overflow: hidden;\n  padding: 8px 0;\n  height: 40px;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--lightestBloobirds);\n  flex-shrink: 0;\n}\n\n.handleTemplate-module_subjectFloatingTemplateVariableContainer__nQj7Z {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  align-items: center;\n}\n\n.handleTemplate-module_subjectFloatingTemplateVariableContainer__nQj7Z svg > path {\n  fill: var(--purple);\n}\n\n.handleTemplate-module_bodyContainer__GAUqH {\n  display: flex;\n  position: relative;\n  align-items: center;\n  padding-top: 8px;\n  min-height: 0;\n  flex: 1;\n  flex-direction: column-reverse;\n  box-sizing: border-box;\n}\n\n.handleTemplate-module_bodyContainer__GAUqH > div:first-child {\n  border-top: var(--verySoftPurple) 1px solid;\n}\n\n.handleTemplate-module_bodyContainer__GAUqH > div:last-child, .handleTemplate-module_bodyContainer__GAUqH > div:last-child > div, .handleTemplate-module_bodyContainer__GAUqH > div:last-child > div > div:first-child {\n  height: 100%;\n}\n\n.handleTemplate-module_bodyContainer__GAUqH > div {\n  border-bottom: 0;\n}\n\n.handleTemplate-module__editor__container_ast__NV6PY {\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  height: 100%;\n}\n\n.handleTemplate-module_separator__qR1-W {\n  width: 1px;\n  height: 24px;\n  background-color: var(--verySoftPurple);\n  margin: 0 16px;\n}\n\n.handleTemplate-module_templateInfoColumn__3gclp {\n  display: flex;\n  flex-direction: column;\n}\n\n.handleTemplate-module_templateInfo__LMkzp {\n  display: flex;\n  margin-bottom: 8px;\n}\n\n.handleTemplate-module_templateInfoEditing__xoZ7H {\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid var(--lightestBloobirds);\n  padding: 6px 0 12px;\n  gap: 4px;\n}\n\n.handleTemplate-module_dateInformation__ij576 {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n  align-items: center;\n}\n\n.handleTemplate-module_editorToolbarSection__5tpmH {\n  border-right: var(--verySoftPurple) 1px solid;\n}\n\n.handleTemplate-module_editorToolbarSection__5tpmH > section {\n  gap: 2px;\n}\n\n.handleTemplate-module_editorToolbarLastSection__Pw95s {\n  border-left: var(--verySoftPurple) 1px solid;\n}\n\n.handleTemplate-module_editorToolbarLastSection__Pw95s svg > path {\n  fill: var(--peanut);\n}\n";
var styles$7 = {"container":"handleTemplate-module_container__BB7uT","header":"handleTemplate-module_header__VXLpc","content":"handleTemplate-module_content__nJALI","formHeader":"handleTemplate-module_formHeader__zX7lx","headerText":"handleTemplate-module_headerText__IbAuH","noPadding":"handleTemplate-module_noPadding__hQaZ5","templateNameContainer":"handleTemplate-module_templateNameContainer__vWfPq","input":"handleTemplate-module_input__I-rl3","placeholder":"handleTemplate-module_placeholder__8myEA","subjectContainer":"handleTemplate-module_subjectContainer__DAVSQ","subjectFloatingTemplateVariableContainer":"handleTemplate-module_subjectFloatingTemplateVariableContainer__nQj7Z","bodyContainer":"handleTemplate-module_bodyContainer__GAUqH","_editor__container_ast":"handleTemplate-module__editor__container_ast__NV6PY","separator":"handleTemplate-module_separator__qR1-W","templateInfoColumn":"handleTemplate-module_templateInfoColumn__3gclp","templateInfo":"handleTemplate-module_templateInfo__LMkzp","templateInfoEditing":"handleTemplate-module_templateInfoEditing__xoZ7H","dateInformation":"handleTemplate-module_dateInformation__ij576","editorToolbarSection":"handleTemplate-module_editorToolbarSection__5tpmH","editorToolbarLastSection":"handleTemplate-module_editorToolbarLastSection__Pw95s"};
styleInject(css_248z$7);

var css_248z$6 = ".segmentationForm-module_container__SzetF {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.segmentationForm-module_section__FoN-g {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 8px;\n  margin: 8px 0 16px;\n}\n\n.segmentationForm-module_title__PnT0n {\n  width: 100%;\n}\n\n.segmentationForm-module_sectionContent__cplBT {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 0 4px;\n  gap: 8px;\n}\n\n.segmentationForm-module_row__-IGky {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: 8px;\n  align-items: center;\n}\n";
var styles$6 = {"container":"segmentationForm-module_container__SzetF","section":"segmentationForm-module_section__FoN-g","title":"segmentationForm-module_title__PnT0n","sectionContent":"segmentationForm-module_sectionContent__cplBT","row":"segmentationForm-module_row__-IGky"};
styleInject(css_248z$6);

var _excluded$2 = ["stage"],
  _excluded2 = ["ref"];
function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }
function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty$f(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof$2(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof$2(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof$2(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Title = function Title(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/jsx(Text, {
    weight: "bold",
    size: "s",
    children: title
  });
};
var SubTitle = function SubTitle(_ref2) {
  var text = _ref2.text;
  return /*#__PURE__*/jsx(Text, {
    color: "softPeanut",
    size: "xs",
    children: text
  });
};
var SwitchRow = function SwitchRow(_ref3) {
  var text = _ref3.text,
    field = _ref3.field,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled;
  return /*#__PURE__*/jsxs("div", {
    className: styles$6.row,
    children: [/*#__PURE__*/jsx(Switch, {
      color: "purple",
      checked: field.value,
      onChange: function onChange(bool) {
        return field.onChange(bool);
      },
      disabled: disabled
    }), /*#__PURE__*/jsx(Text, {
      size: "s",
      weight: "medium",
      children: text
    })]
  });
};
var SegmentationFieldsByStage = function SegmentationFieldsByStage(_ref4) {
  var _segmentationFields$s;
  var segmentationFields = _ref4.segmentationFields,
    _ref4$segmentationFie = _ref4.segmentationField,
    selectedSegmentation = _ref4$segmentationFie.value,
    setSelectedSegmentation = _ref4$segmentationFie.onChange,
    stage = _ref4.stage,
    _ref4$withTitle = _ref4.withTitle,
    withTitle = _ref4$withTitle === void 0 ? false : _ref4$withTitle;
  return /*#__PURE__*/jsxs("div", {
    className: styles$6.sectionContent,
    children: [withTitle && /*#__PURE__*/jsx(Text, {
      size: "xs",
      color: "softPeanut",
      children: toSentenceCase(stage.toLowerCase())
    }), (_segmentationFields$s = segmentationFields[stage]) === null || _segmentationFields$s === void 0 ? void 0 : _segmentationFields$s.map(function (segmentation) {
      var _selectedSegmentation, _segmentation$values;
      var selectedValues = (_selectedSegmentation = selectedSegmentation[stage]) === null || _selectedSegmentation === void 0 ? void 0 : _selectedSegmentation[segmentation.id];
      var onChange = function onChange(values) {
        var _selectedSegmentation2 = selectedSegmentation[stage],
          _segmentation$id = segmentation.id;
          _selectedSegmentation2[_segmentation$id];
          var stageValues = _objectWithoutProperties$2(_selectedSegmentation2, [_segmentation$id].map(_toPropertyKey));
        setSelectedSegmentation(_objectSpread$f(_objectSpread$f({}, selectedSegmentation), {}, _defineProperty$f({}, stage, _objectSpread$f(_objectSpread$f({}, stageValues), values.length && _defineProperty$f({}, segmentation.id, values)))));
      };
      var renderValue = function renderValue(values) {
        if (values && values.length) {
          var selectedNames = values.map(function (id) {
            return segmentation.values.find(function (v) {
              return v.id === id;
            }).name;
          });
          if (selectedNames.length === segmentation.values.length) {
            return 'All values selected';
          } else if (selectedNames.length === 1) {
            return selectedNames[0];
          } else {
            return selectedNames.length + ' selected: ' + (selectedNames === null || selectedNames === void 0 ? void 0 : selectedNames.join(', '));
          }
        }
      };
      return /*#__PURE__*/jsx(MultiSelect, {
        size: "small",
        value: selectedValues ? selectedValues : [],
        width: "100%",
        placeholder: 'Select ' + segmentation.name,
        renderDisplayValue: renderValue,
        onChange: onChange,
        selectAllOption: true,
        children: (_segmentation$values = segmentation.values) === null || _segmentation$values === void 0 ? void 0 : _segmentation$values.map(function (value) {
          return /*#__PURE__*/jsx(CheckItem, {
            value: value.id,
            checked: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(value.id),
            children: value.name
          }, value.id);
        })
      }, segmentation.id);
    })]
  });
};
var SegmentationFields = function SegmentationFields(_ref6) {
  var stage = _ref6.stage,
    props = _objectWithoutProperties$2(_ref6, _excluded$2);
  var stages = stage === TemplateStage.All ? [TemplateStage.Prospecting, TemplateStage.Sales] : [stage];
  return /*#__PURE__*/jsx(Fragment, {
    children: stages.map(function (s) {
      return /*#__PURE__*/jsx(SegmentationFieldsByStage, _objectSpread$f({
        stage: s,
        withTitle: stage === TemplateStage.All
      }, props), 'SegmentationFieldsByStage' + s);
    })
  });
};
var SegmentationForm = function SegmentationForm(_ref7) {
  var _settings$user;
  var canBeBattlecard = _ref7.canBeBattlecard;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useController = useController({
      control: control,
      name: 'stage'
    }),
    _useController$field = _useController.field;
    _useController$field.ref;
    var stageField = _objectWithoutProperties$2(_useController$field, _excluded2);
  var _usePlaybookSegmentat = usePlaybookSegmentation(stageField.value),
    segmentationFields = _usePlaybookSegmentat.segmentationFields;
  var _useActiveUserSetting = useActiveUserSettings(),
    settings = _useActiveUserSetting.settings;
  var isAdmin = settings === null || settings === void 0 ? void 0 : (_settings$user = settings.user) === null || _settings$user === void 0 ? void 0 : _settings$user.accountAdmin;
  var _useController2 = useController({
      control: control,
      name: 'visibility'
    }),
    visibleField = _useController2.field;
  var _useController3 = useController({
      control: control,
      name: 'isOfficial'
    }),
    officialField = _useController3.field;
  var _useController4 = useController({
      control: control,
      name: 'isBattlecard'
    }),
    battlecardField = _useController4.field;
  var _useController5 = useController({
      control: control,
      name: 'segmentationValues'
    }),
    segmentationField = _useController5.field;
  var visibleFieldFunctions = {
    value: visibleField.value === 'PUBLIC',
    onChange: function onChange(b) {
      return visibleField.onChange(b ? 'PUBLIC' : 'PRIVATE');
    }
  };
  var renderStage = function renderStage(stage) {
    switch (stage) {
      case TemplateStage.All:
        return 'Prospect and Sales stage';
      case TemplateStage.Prospecting:
        return 'Prospect stage';
      case TemplateStage.Sales:
        return 'Sales stage';
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles$6.container,
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$6.section,
      children: [/*#__PURE__*/jsx(Title, {
        title: "Stage"
      }), /*#__PURE__*/jsxs(Select, _objectSpread$f(_objectSpread$f({
        size: "small",
        placeholder: "Stage"
      }, stageField), {}, {
        width: '100%',
        borderless: false,
        renderDisplayValue: renderStage,
        children: [/*#__PURE__*/jsx(Item, {
          value: TemplateStage.All,
          children: "All"
        }), /*#__PURE__*/jsx(Item, {
          value: TemplateStage.Prospecting,
          children: "Prospect stage"
        }), /*#__PURE__*/jsx(Item, {
          value: TemplateStage.Sales,
          children: "Sales stage"
        })]
      }))]
    }), /*#__PURE__*/jsxs("div", {
      className: styles$6.section,
      children: [/*#__PURE__*/jsx(Title, {
        title: "Options"
      }), /*#__PURE__*/jsx(SubTitle, {
        text: "Can choose more than one"
      }), /*#__PURE__*/jsxs("div", {
        className: styles$6.sectionContent,
        children: [/*#__PURE__*/jsx(SwitchRow, {
          text: "Visible for all team members",
          field: visibleFieldFunctions
        }), /*#__PURE__*/jsx(SwitchRow, {
          text: "Official Playbook Template",
          field: officialField,
          disabled: !isAdmin
        }), canBeBattlecard && /*#__PURE__*/jsx(SwitchRow, {
          text: "Playbook battlecard",
          field: battlecardField
        })]
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: styles$6.section,
      children: [/*#__PURE__*/jsx(Title, {
        title: "Categorization"
      }), stageField.value !== TemplateStage.All && /*#__PURE__*/jsx(SubTitle, {
        text: "Categorizing enables you to easily filter your templates"
      }), segmentationFields && /*#__PURE__*/jsx(SegmentationFields, {
        segmentationFields: segmentationFields,
        segmentationField: segmentationField,
        stage: stageField.value
      })]
    })]
  });
};

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty$e(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var labelProps = {
  uppercase: false,
  overrideStyle: {
    fontSize: '12px',
    padding: '2px 4px',
    height: '20px',
    fontWeight: 'var(--regular)'
  }
};
var StageLabel$1 = function StageLabel(_ref) {
  var stage = _ref.stage;
  switch (stage) {
    case TemplateStage.Prospecting:
      return /*#__PURE__*/jsx(Label, _objectSpread$e(_objectSpread$e({
        color: "lightestCall",
        textColor: "extraCall"
      }, labelProps), {}, {
        children: "Prospecting"
      }));
    case TemplateStage.Sales:
      return /*#__PURE__*/jsx(Label, _objectSpread$e(_objectSpread$e({
        color: "lightPeanut",
        textColor: "peanut"
      }, labelProps), {}, {
        children: "Sales"
      }));
    case TemplateStage.All:
      return /*#__PURE__*/jsx(Label, _objectSpread$e(_objectSpread$e({
        color: "lightBloobirds",
        textColor: "bloobirds"
      }, labelProps), {}, {
        children: "Prospecting and Sales"
      }));
    default:
      return /*#__PURE__*/jsx(Label, _objectSpread$e(_objectSpread$e({
        color: "lightTomato",
        textColor: "tomato"
      }, labelProps), {}, {
        children: "\u26A0\uFE0F No Stage"
      }));
  }
};
var DateInformation = function DateInformation(_ref2) {
  var _ref2$data = _ref2.data,
    title = _ref2$data.title,
    user = _ref2$data.user,
    date = _ref2$data.date,
    icon = _ref2$data.icon;
  return /*#__PURE__*/jsxs("div", {
    className: styles$7.dateInformation,
    children: [/*#__PURE__*/jsx(Icon, {
      name: icon,
      size: 18,
      color: "lightPurple"
    }), /*#__PURE__*/jsx(Text, {
      size: "xs",
      weight: "bold",
      children: title
    }), /*#__PURE__*/jsx("div", {
      children: /*#__PURE__*/jsxs(Text, {
        size: "xs",
        weight: "medium",
        children: [user, " on ", date]
      })
    })]
  });
};
function formatDatetime(value) {
  if (!value) return 'Undefined date';
  return formatDate(new Date(value + (value.slice(-1) === 'Z' ? '' : 'Z')), 'MMM dd yyyy, HH:mm (z)');
}
var TemplateInformation = function TemplateInformation(_ref3) {
  var _users$find;
  var template = _ref3.template;
  var _useUserSearch = useUserSearch(),
    users = _useUserSearch.users;
  var creationInfo = {
    title: 'Created by',
    user: (_users$find = users.find(function (user) {
      return user.id === template.createdBy;
    })) === null || _users$find === void 0 ? void 0 : _users$find.name,
    date: formatDatetime(template.creationDatetime),
    icon: 'calendar'
  };
  var lastUpdatedInfo = {
    title: 'Last updated by',
    user: template.updatedBy,
    date: formatDatetime(template.updateDatetime),
    icon: 'refresh'
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles$7.templateInfoEditing,
    children: [/*#__PURE__*/jsx(DateInformation, {
      data: creationInfo
    }), /*#__PURE__*/jsx(DateInformation, {
      data: lastUpdatedInfo
    })]
  });
};
var TemplateHeader$1 = function TemplateHeader() {
  var _useFormContext = useFormContext(),
    watch = _useFormContext.watch;
  var stage = watch('stage');
  var visible = watch('visibility');
  var official = watch('isOfficial');
  var battlecard = watch('isBattlecard');
  var _useContext = useContext(TemplateFormContext),
    template = _useContext.template;
  var isEditing = !!template.id;
  var isSnippet = (template === null || template === void 0 ? void 0 : template.type) === TEMPLATE_TYPES.SNIPPET;
  var getColor = function getColor(selected) {
    return selected ? 'purple' : 'lightPurple';
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles$7.templateInfoColumn,
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$7.templateInfo,
      children: [/*#__PURE__*/jsx(StageLabel$1, {
        stage: stage
      }), /*#__PURE__*/jsx("div", {
        className: styles$7.separator
      }), /*#__PURE__*/jsx(Tooltip, {
        title: visible === 'PUBLIC' ? 'Visible for all team members' : 'Visible just for me',
        position: "top",
        children: /*#__PURE__*/jsx(Icon, {
          name: "eye",
          color: getColor(visible === 'PUBLIC')
        })
      }), /*#__PURE__*/jsx(Tooltip, {
        title: "Official Playbook Template",
        position: "top",
        children: /*#__PURE__*/jsx(Icon, {
          name: "bookmark",
          color: getColor(official)
        })
      }), isSnippet && /*#__PURE__*/jsx(Tooltip, {
        title: "Playbook battlecard",
        position: "top",
        children: /*#__PURE__*/jsx(Icon, {
          name: "battlecards",
          color: getColor(battlecard)
        })
      })]
    }), isEditing && /*#__PURE__*/jsx(TemplateInformation, {
      template: template
    })]
  });
};

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty$d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$b(arr, i) { return _arrayWithHoles$b(arr) || _iterableToArrayLimit$b(arr, i) || _unsupportedIterableToArray$b(arr, i) || _nonIterableRest$b(); }
function _nonIterableRest$b() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen); }
function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$b(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$b(arr) { if (Array.isArray(arr)) return arr; }
var NameFormEditor = function NameFormEditor() {
  var _errors$name;
  var _useContext = useContext(TemplateFormContext),
    storeEditorRef = _useContext.storeEditorRef,
    focusedRef = _useContext.focusedRef;
  var _useState = useState(null),
    _useState2 = _slicedToArray$b(_useState, 2),
    editor = _useState2[0],
    _setEditor = _useState2[1];
  var _useContext2 = useContext(TemplateFormContext),
    template = _useContext2.template,
    setElements = _useContext2.setElements,
    plugins = _useContext2.plugins;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control,
    errors = _useFormContext.formState.errors;
  var _useController = useController({
      control: control,
      name: 'name',
      rules: {
        validate: function validate(fieldValue) {
          // @ts-ignore
          var value = fieldValue && (fieldValue[0].children ? fieldValue[0].children[0].text : fieldValue[0].text);
          if (value === undefined || value === '') return 'A name for the template is required';else return undefined;
        }
      }
    }),
    field = _useController.field;
  useEffect(function () {
    setElements(field.value, template.name, editor, true);
  }, [template, editor]);
  return /*#__PURE__*/jsxs("div", {
    className: styles$7.templateNameContainer,
    onClick: function onClick() {
      return focusedRef.current = 2;
    },
    children: [/*#__PURE__*/jsx(RichTextEditor, _objectSpread$d({
      id: "templateNameEditor",
      placeholder: "Template name...",
      plugins: plugins,
      setEditor: function setEditor(value) {
        _setEditor(value);
        storeEditorRef(value);
      },
      style: {
        width: '100%',
        padding: 0
      }
    }, field)), /*#__PURE__*/jsx(Text, {
      size: "xxs",
      color: "tomato",
      children: errors === null || errors === void 0 ? void 0 : (_errors$name = errors.name) === null || _errors$name === void 0 ? void 0 : _errors$name.message
    })]
  });
};

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty$c(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$a(arr, i) { return _arrayWithHoles$a(arr) || _iterableToArrayLimit$a(arr, i) || _unsupportedIterableToArray$a(arr, i) || _nonIterableRest$a(); }
function _nonIterableRest$a() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }
function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$a(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$a(arr) { if (Array.isArray(arr)) return arr; }
var MainContentFormEditor = function MainContentFormEditor(_ref) {
  var accountId = _ref.accountId,
    attachedFiles = _ref.attachedFiles,
    removeAttachedFile = _ref.removeAttachedFile,
    uploadAttachedFile = _ref.uploadAttachedFile;
  var hasMeetingLinksEnabled = useMeetingLinksEnabled(accountId);
  var _useState = useState(null),
    _useState2 = _slicedToArray$a(_useState, 2),
    editor = _useState2[0],
    _setEditor = _useState2[1];
  var _useContext = useContext(TemplateFormContext),
    focusedRef = _useContext.focusedRef,
    storeEditorRef = _useContext.storeEditorRef,
    template = _useContext.template,
    setElements = _useContext.setElements;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  //WARNING: the field is named content not body
  var _useController = useController({
      control: control,
      name: 'content'
    }),
    field = _useController.field;
  var bodyPlugins = useRichTextEditorPlugins({
    templateVariables: true,
    rawHTMLBlock: true
  });
  useEffect(function () {
    setElements(field.value, template.content, editor);
  }, [template, editor]);
  var showAttachmentSection = template.type !== TEMPLATE_TYPES.SNIPPET;
  return /*#__PURE__*/jsx("div", {
    className: styles$7.bodyContainer,
    onClick: function onClick() {
      return focusedRef.current = 4;
    },
    children: /*#__PURE__*/jsx(RichTextEditor, _objectSpread$c(_objectSpread$c({
      id: "templateEditorBody",
      placeholder: "Body",
      plugins: bodyPlugins,
      setEditor: function setEditor(value) {
        _setEditor(value);
        storeEditorRef(value);
      },
      style: {
        width: '100%',
        padding: 0
      }
    }, field), {}, {
      children: function children(editor) {
        return /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs(EditorToolbar, {
            backgroundColor: "white",
            children: [/*#__PURE__*/jsx("div", {
              className: styles$7.editorToolbarSection,
              children: /*#__PURE__*/jsx(EditorToolbarControlsSection, {
                color: "peanut"
              })
            }), /*#__PURE__*/jsx("div", {
              className: styles$7.editorToolbarSection,
              children: /*#__PURE__*/jsx(EditorToolbarFontStylesSection, {
                color: "peanut"
              })
            }), /*#__PURE__*/jsx("div", {
              className: styles$7.editorToolbarSection,
              children: /*#__PURE__*/jsx(EditorToolbarTextMarksSection, {
                color: "peanut"
              })
            }), /*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx(EditorToolbarListsSection, {
                color: "peanut"
              })
            }), showAttachmentSection && /*#__PURE__*/jsx("div", {
              className: styles$7.editorToolbarLastSection,
              children: /*#__PURE__*/jsxs(EditorToolbarSection, {
                children: [hasMeetingLinksEnabled && /*#__PURE__*/jsx(EditorToolbarMeetingLink, {
                  color: "peanut"
                }), /*#__PURE__*/jsx(TemplateEditorToolbarFileAttachment, {
                  onAttachment: uploadAttachedFile,
                  color: "peanut"
                }), /*#__PURE__*/jsx(TemplateEditorToolbarImage, {
                  color: "peanut"
                }), /*#__PURE__*/jsx(EditorToolbarTemplateVariable, {})]
              })
            })]
          }), (attachedFiles === null || attachedFiles === void 0 ? void 0 : attachedFiles.length) > 0 && /*#__PURE__*/jsx(AttachmentList, {
            files: attachedFiles,
            onDelete: removeAttachedFile
          }), /*#__PURE__*/jsx("div", {
            className: styles$7._editor__container_ast,
            children: editor
          })]
        });
      }
    }))
  });
};

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty$b(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$9(arr, i) { return _arrayWithHoles$9(arr) || _iterableToArrayLimit$9(arr, i) || _unsupportedIterableToArray$9(arr, i) || _nonIterableRest$9(); }
function _nonIterableRest$9() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }
function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$9(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$9(arr) { if (Array.isArray(arr)) return arr; }
var FieldInput = function FieldInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder;
  return /*#__PURE__*/jsxs("div", {
    className: styles$7.input,
    children: [/*#__PURE__*/jsx("input", {
      id: "shortcutInput",
      type: "text",
      placeholder: "Shortcut name...",
      value: value,
      onChange: onChange
    }), !value && /*#__PURE__*/jsx("span", {
      className: styles$7.placeholder,
      children: placeholder
    })]
  });
};
var SubjectFormEditor = function SubjectFormEditor() {
  var _useContext = useContext(TemplateFormContext),
    storeEditorRef = _useContext.storeEditorRef,
    focusedRef = _useContext.focusedRef;
  var _useState = useState(null),
    _useState2 = _slicedToArray$9(_useState, 2),
    subjectEditor = _useState2[0],
    setSubjectEditor = _useState2[1];
  var _useContext2 = useContext(TemplateFormContext),
    template = _useContext2.template,
    setElements = _useContext2.setElements,
    plugins = _useContext2.plugins;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control;
  var _useController = useController({
      control: control,
      name: 'subject'
    }),
    field = _useController.field;
  useEffect(function () {
    setElements(field.value, template.subject, subjectEditor);
  }, [template === null || template === void 0 ? void 0 : template.subject, subjectEditor]);
  return /*#__PURE__*/jsx("div", {
    className: styles$7.subjectContainer,
    onClick: function onClick() {
      return focusedRef.current = 3;
    },
    children: /*#__PURE__*/jsx(RichTextEditor, _objectSpread$b(_objectSpread$b({
      id: "templateSubjectEditor",
      placeholder: "Subject",
      plugins: plugins,
      setEditor: function setEditor(value) {
        setSubjectEditor(value);
        storeEditorRef(value);
      },
      style: {
        width: '100%',
        padding: 0
      }
    }, field), {}, {
      children: function children(editor) {
        return /*#__PURE__*/jsxs("div", {
          className: styles$7.subjectFloatingTemplateVariableContainer,
          children: [editor, subjectEditor && /*#__PURE__*/jsx(FloatingTemplateVariable, {
            editor: subjectEditor
          })]
        });
      }
    }))
  });
};
var ShortCutFormEditor = function ShortCutFormEditor() {
  var _useFormContext2 = useFormContext(),
    control = _useFormContext2.control;
  var _useController2 = useController({
      control: control,
      name: 'shortcut'
    }),
    field = _useController2.field;
  React.useRef(null);

  /*   useLayoutEffect(() => {
    setTimeout(() => storeEditorRef(({ id: 'shortcutInput' } as unknown) as BaseEditor), 100);
  }, []);*/

  return /*#__PURE__*/jsxs("div", {
    className: styles$7.templateNameContainer,
    children: [/*#__PURE__*/jsx(Text, {
      size: "xxs",
      color: "softPeanut",
      children: "To use a shortcut, type \u201C/\u201D followed by the snippet name"
    }), /*#__PURE__*/jsx(FieldInput, {
      value: field.value ? '/' + field.value : '',
      onChange: function onChange(value) {
        var cleanValue = value.target.value.replace(/\s|\//g, '');
        var parsedValue = cleanValue.length > 49 ? cleanValue.slice(0, 49) : cleanValue;
        field.onChange(parsedValue);
      },
      placeholder: "Shortcut name..."
    })]
  });
};
var TemplateFormFieldsByType = function TemplateFormFieldsByType() {
  var _useContext3 = useContext(TemplateFormContext),
    template = _useContext3.template;
  switch (template.type) {
    case TEMPLATE_TYPES.EMAIL:
      return /*#__PURE__*/jsx(SubjectFormEditor, {});
    case TEMPLATE_TYPES.SNIPPET:
      return /*#__PURE__*/jsx(ShortCutFormEditor, {});
    default:
      return /*#__PURE__*/jsx(Fragment, {});
  }
};

var _excluded$1 = ["accountId", "template", "contextProps"];
function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty$a(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TemplateFormContext = /*#__PURE__*/createContext(null);
var TemplateForm = function TemplateForm(_ref) {
  var accountId = _ref.accountId,
    template = _ref.template,
    contextProps = _ref.contextProps,
    attachedFilesFunctions = _objectWithoutProperties$1(_ref, _excluded$1);
  var _useFormContext = useFormContext(),
    isDirty = _useFormContext.formState.isDirty;
  var singleLinePlugins = useRichTextEditorPlugins({
    templateVariables: true,
    marks: false,
    elements: false,
    images: false,
    autoReplace: false,
    singleLine: true,
    replaceParagraphs: true
  });
  var setElements = function setElements(templateFieldValue, templateValue, editor) {
    var paragraph = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (editor && !!(isDirty && templateFieldValue ? templateFieldValue : templateValue)) {
      var toJson = function toJson(e) {
        return typeof e === 'string' ? JSON.parse(e) : e;
      };
      var createParagraph = function createParagraph(text) {
        return {
          type: 'p',
          children: [{
            text: text
          }]
        };
      };
      var parseValue = function parseValue(e) {
        return paragraph ? createParagraph(e) : toJson(e);
      };
      var value = isDirty && templateFieldValue ? templateFieldValue : parseValue(templateValue);
      resetEditorChildren(editor);
      insertElements(editor, value, {
        at: [0]
      });
    }
  };
  return /*#__PURE__*/jsxs(TemplateFormContext.Provider, {
    value: _objectSpread$a(_objectSpread$a({}, contextProps), {}, {
      template: template,
      setElements: setElements,
      plugins: singleLinePlugins
    }),
    children: [/*#__PURE__*/jsx(TemplateHeader$1, {}), /*#__PURE__*/jsx(NameFormEditor, {}), /*#__PURE__*/jsx(TemplateFormFieldsByType, {}), /*#__PURE__*/jsx(MainContentFormEditor, _objectSpread$a({
      accountId: accountId
    }, attachedFilesFunctions))]
  });
};

var _segmentationValues;
function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty$9(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray$8(arr, i) { return _arrayWithHoles$8(arr) || _iterableToArrayLimit$8(arr, i) || _unsupportedIterableToArray$8(arr, i) || _nonIterableRest$8(); }
function _nonIterableRest$8() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }
function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$8(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$8(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }
function isSegmentationValues(values) {
  return !!values && (!!values[TemplateStage.Prospecting] && _typeof$1(values[TemplateStage.Prospecting]) === 'object' || !!values[TemplateStage.Sales] && _typeof$1(values[TemplateStage.Sales]) === 'object');
}
var defaultTemplate = {
  segmentationValues: (_segmentationValues = {}, _defineProperty$9(_segmentationValues, TemplateStage.Prospecting, {}), _defineProperty$9(_segmentationValues, TemplateStage.Sales, {}), _segmentationValues),
  stage: TemplateStage.All,
  visibility: 'PRIVATE',
  isOfficial: false,
  isBattlecard: false
};
var getSegmentationValuesToSendToDB = function getSegmentationValuesToSendToDB(segmentationValues, stage) {
  var newValues = {};
  if (stage === TemplateStage.All) {
    var _newValues;
    newValues = (_newValues = {}, _defineProperty$9(_newValues, TemplateStage.Prospecting, {}), _defineProperty$9(_newValues, TemplateStage.Sales, {}), _newValues);
    Object.entries(segmentationValues[TemplateStage.Prospecting]).forEach(function (_ref) {
      var _ref2 = _slicedToArray$8(_ref, 2),
        fieldId = _ref2[0],
        values = _ref2[1];
      if (values && values.length) {
        newValues[TemplateStage.Prospecting] = _objectSpread$9(_objectSpread$9({}, newValues[TemplateStage.Prospecting] || {}), {}, _defineProperty$9({}, fieldId, values));
      }
    });
    Object.entries(segmentationValues[TemplateStage.Sales]).forEach(function (_ref3) {
      var _ref4 = _slicedToArray$8(_ref3, 2),
        fieldId = _ref4[0],
        values = _ref4[1];
      if (values && values.length) {
        newValues[TemplateStage.Sales] = _objectSpread$9(_objectSpread$9({}, newValues[TemplateStage.Sales] || {}), {}, _defineProperty$9({}, fieldId, values));
      }
    });
  } else {
    newValues = _defineProperty$9({}, stage, {});
    Object.entries(segmentationValues[stage]).forEach(function (_ref5) {
      var _ref6 = _slicedToArray$8(_ref5, 2),
        fieldId = _ref6[0],
        values = _ref6[1];
      if (values && values.length) {
        newValues[stage] = _objectSpread$9(_objectSpread$9({}, newValues[stage]), {}, _defineProperty$9({}, fieldId, values));
      }
    });
  }
  return newValues;
};
var parseSegmentationValues = function parseSegmentationValues(initValues, stage) {
  var _ref7, _ref8, _ref9;
  if (isSegmentationValues(initValues)) {
    return _objectSpread$9(_objectSpread$9({}, defaultTemplate.segmentationValues), initValues);
  }
  if (!!initValues && _typeof$1(initValues) === 'object') {
    switch (stage) {
      case TemplateStage.Prospecting:
        return _ref7 = {}, _defineProperty$9(_ref7, TemplateStage.Prospecting, initValues), _defineProperty$9(_ref7, TemplateStage.Sales, {}), _ref7;
      case TemplateStage.Sales:
        return _ref8 = {}, _defineProperty$9(_ref8, TemplateStage.Prospecting, {}), _defineProperty$9(_ref8, TemplateStage.Sales, initValues), _ref8;
      case TemplateStage.All:
      default:
        return _ref9 = {}, _defineProperty$9(_ref9, TemplateStage.Prospecting, {}), _defineProperty$9(_ref9, TemplateStage.Sales, {}), _ref9;
    }
  } else {
    var _ref10;
    return _ref10 = {}, _defineProperty$9(_ref10, TemplateStage.Prospecting, {}), _defineProperty$9(_ref10, TemplateStage.Sales, {}), _ref10;
  }
};

var css_248z$5 = ".playbookConfirmationModal-module_modal_header__avSw0 {\n  background: var(--verySoftPurple) !important;\n  align-items: center;\n  height: 60px;\n}\n\n.playbookConfirmationModal-module_modal_title__6nzNB {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.playbookConfirmationModal-module_modal_text__tf253 {\n  line-height: 24px;\n  margin-bottom: 12px;\n}\n\n.playbookConfirmationModal-module_modal_text_delete__3N-3f {\n  line-height: 24px;\n  margin-bottom: 12px;\n  text-align: center;\n}\n\n.playbookConfirmationModal-module_cadences__WmlCb {\n  margin-top: 8px;\n}\n\n.playbookConfirmationModal-module_cadence__XYsJQ {\n  padding-left: 60px;\n  margin-bottom: 4px;\n  gap: 8px;\n  display: flex;\n  align-items: center;\n}\n\n.playbookConfirmationModal-module_buttons__P-TrU {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  padding: 8px 28px 0;\n}\n\n.playbookConfirmationModal-module_button_end__rew5g {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: flex-end;\n  padding: 8px 28px 0;\n}\n\n.playbookConfirmationModal-module_buttons_right__vI4R9 {\n  display: flex;\n  gap: 16px;\n}\n";
var styles$5 = {"modal_header":"playbookConfirmationModal-module_modal_header__avSw0","modal_title":"playbookConfirmationModal-module_modal_title__6nzNB","modal_text":"playbookConfirmationModal-module_modal_text__tf253","modal_text_delete":"playbookConfirmationModal-module_modal_text_delete__3N-3f","cadences":"playbookConfirmationModal-module_cadences__WmlCb","cadence":"playbookConfirmationModal-module_cadence__XYsJQ","buttons":"playbookConfirmationModal-module_buttons__P-TrU","button_end":"playbookConfirmationModal-module_button_end__rew5g","buttons_right":"playbookConfirmationModal-module_buttons_right__vI4R9"};
styleInject(css_248z$5);

var useCadencesUsingTemplate = function useCadencesUsingTemplate(templateId) {
  var _cadences$data;
  var _useSWR = useSWR(templateId ? "/messaging/messagingTemplates/".concat(templateId, "/cadences") : null, function (url) {
      return api.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        data: {}
      });
    }),
    cadences = _useSWR.data,
    isValidating = _useSWR.isValidating;
  var cadencesUsingTemplate = cadences === null || cadences === void 0 ? void 0 : (_cadences$data = cadences.data) === null || _cadences$data === void 0 ? void 0 : _cadences$data.cadences;
  return {
    cadencesUsingTemplate: cadencesUsingTemplate,
    isValidating: isValidating
  };
};

function ConfirmationModalHeader(_ref) {
  var icon = _ref.icon,
    text = _ref.text,
    onClose = _ref.onClose;
  return /*#__PURE__*/jsxs(ModalHeader, {
    variant: "gradient",
    color: "purple",
    className: styles$5.modal_header,
    children: [/*#__PURE__*/jsx(ModalTitle, {
      variant: "gradient",
      children: /*#__PURE__*/jsxs("div", {
        className: styles$5.modal_title,
        children: [/*#__PURE__*/jsx(Icon, {
          color: "purple",
          name: icon,
          size: 24
        }), /*#__PURE__*/jsx(Text, {
          color: "peanut",
          size: "m",
          children: text
        })]
      })
    }), /*#__PURE__*/jsx(ModalCloseIcon, {
      size: "small",
      onClick: onClose,
      color: "purple"
    })]
  });
}
function EditTemplateConfirmationModal(props) {
  var _cadencesUsingTemplat;
  var openMode = props.openMode,
    onClose = props.onClose,
    onAccept = props.onAccept,
    cadencesUsingTemplate = props.cadencesUsingTemplate;
  return /*#__PURE__*/jsxs(Modal, {
    open: !!openMode,
    onClose: onClose,
    width: 640,
    children: [/*#__PURE__*/jsx(ConfirmationModalHeader, {
      icon: "autoMail",
      text: "Save existing email template",
      onClose: onClose
    }), /*#__PURE__*/jsxs(ModalContent, {
      children: [/*#__PURE__*/jsxs(Text, {
        color: "softPeanut",
        size: "s",
        className: styles$5.modal_text,
        children: ["This template is being used in ", (_cadencesUsingTemplat = cadencesUsingTemplate === null || cadencesUsingTemplate === void 0 ? void 0 : cadencesUsingTemplate.length) !== null && _cadencesUsingTemplat !== void 0 ? _cadencesUsingTemplat : '0', " cadence", (cadencesUsingTemplate === null || cadencesUsingTemplate === void 0 ? void 0 : cadencesUsingTemplate.length) === 1 ? '' : 's', ", this changes will be applied to all the auto-email tasks that are using this template and are already scheduled."]
      }), cadencesUsingTemplate && /*#__PURE__*/jsx("div", {
        className: styles$5.cadences,
        children: cadencesUsingTemplate === null || cadencesUsingTemplate === void 0 ? void 0 : cadencesUsingTemplate.map(function (cadence) {
          return 'name' in cadence && /*#__PURE__*/jsxs("div", {
            className: styles$5.cadence,
            children: [/*#__PURE__*/jsx(Icon, {
              name: 'circle',
              color: "lightPurple"
            }), /*#__PURE__*/jsx(Text, {
              color: "softPeanut",
              size: "s",
              children: cadence.name
            })]
          }, cadence.id);
        })
      })]
    }), /*#__PURE__*/jsx(ModalFooter, {
      children: /*#__PURE__*/jsxs("div", {
        className: styles$5.buttons,
        children: [/*#__PURE__*/jsx(Button, {
          variant: "clear",
          color: "purple",
          onClick: onClose,
          children: "Cancel"
        }), /*#__PURE__*/jsx("div", {
          className: styles$5.buttons_right,
          children: /*#__PURE__*/jsx(Button, {
            variant: "primary",
            color: "purple",
            onClick: onAccept,
            children: "Accept"
          })
        })]
      })
    })]
  });
}
function DeleteConfirmationModal(props) {
  var openMode = props.openMode,
    templateId = props.templateId,
    onClose = props.onClose,
    onAccept = props.onAccept;
  var _useCadencesUsingTemp = useCadencesUsingTemplate(templateId),
    cadencesUsingTemplate = _useCadencesUsingTemp.cadencesUsingTemplate,
    isValidating = _useCadencesUsingTemp.isValidating;
  if (isValidating) {
    return null;
  } else if (cadencesUsingTemplate && cadencesUsingTemplate.length) {
    var _cadencesUsingTemplat2;
    return /*#__PURE__*/jsxs(Modal, {
      open: !!openMode,
      onClose: onClose,
      width: 640,
      children: [/*#__PURE__*/jsx(ConfirmationModalHeader, {
        icon: "trashFull",
        text: "Delete template",
        onClose: onClose
      }), /*#__PURE__*/jsxs(ModalContent, {
        children: [/*#__PURE__*/jsxs(Text, {
          color: "softPeanut",
          size: "s",
          className: styles$5.modal_text,
          children: ["This template is being used in ", (_cadencesUsingTemplat2 = cadencesUsingTemplate === null || cadencesUsingTemplate === void 0 ? void 0 : cadencesUsingTemplate.length) !== null && _cadencesUsingTemplat2 !== void 0 ? _cadencesUsingTemplat2 : '0', " cadence", (cadencesUsingTemplate === null || cadencesUsingTemplate === void 0 ? void 0 : cadencesUsingTemplate.length) === 1 ? '' : 's', ", if you want to delete it unlink the template from these cadences."]
        }), cadencesUsingTemplate && /*#__PURE__*/jsx("div", {
          className: styles$5.cadences,
          children: cadencesUsingTemplate === null || cadencesUsingTemplate === void 0 ? void 0 : cadencesUsingTemplate.map(function (cadence) {
            return 'name' in cadence && /*#__PURE__*/jsxs("div", {
              className: styles$5.cadence,
              children: [/*#__PURE__*/jsx(Icon, {
                name: 'circle',
                color: "lightPurple"
              }), /*#__PURE__*/jsx(Text, {
                color: "softPeanut",
                size: "s",
                children: cadence.name
              })]
            }, cadence.id);
          })
        })]
      }), /*#__PURE__*/jsx(ModalFooter, {
        children: /*#__PURE__*/jsx("div", {
          className: styles$5.button_end,
          children: /*#__PURE__*/jsx(Button, {
            variant: "primary",
            color: "purple",
            onClick: onClose,
            children: "Close"
          })
        })
      })]
    });
  } else {
    return /*#__PURE__*/jsx(DiscardConfirmationModal, {
      openMode: openMode,
      templateId: templateId,
      onClose: onClose,
      onAccept: onAccept
    });
  }
}
function DiscardConfirmationModal(props) {
  var openMode = props.openMode,
    templateId = props.templateId,
    onClose = props.onClose,
    onAccept = props.onAccept;
  return /*#__PURE__*/jsxs(Modal, {
    open: !!openMode,
    onClose: onClose,
    width: 500,
    children: [/*#__PURE__*/jsx(ConfirmationModalHeader, {
      icon: "cross",
      text: "".concat(openMode, " ").concat(templateId ? 'changes' : 'template'),
      onClose: onClose
    }), /*#__PURE__*/jsx(ModalContent, {
      children: /*#__PURE__*/jsxs(Text, {
        size: "s",
        className: styles$5.modal_text_delete,
        children: [openMode === 'Discard' ? 'Changes won’t be saved. ' : 'You are about to delete a template. ', /*#__PURE__*/jsx(Text, {
          htmlTag: "span",
          size: "s",
          weight: "bold",
          children: "This action cannot be undone."
        }), ' ', "Are you sure you want to do this?"]
      })
    }), /*#__PURE__*/jsx(ModalFooter, {
      children: /*#__PURE__*/jsxs("div", {
        className: styles$5.buttons,
        children: [/*#__PURE__*/jsx(Button, {
          variant: "clear",
          color: "purple",
          onClick: onClose,
          children: "Cancel"
        }), /*#__PURE__*/jsx(Button, {
          variant: "primary",
          color: "tomato",
          onClick: onAccept,
          children: openMode
        })]
      })
    })]
  });
}
function PlaybookConfirmationModal(_ref2) {
  var _ref2$openMode = _ref2.openMode,
    openMode = _ref2$openMode === void 0 ? '' : _ref2$openMode,
    _ref2$cadencesUsingTe = _ref2.cadencesUsingTemplate,
    cadencesUsingTemplate = _ref2$cadencesUsingTe === void 0 ? [] : _ref2$cadencesUsingTe,
    _ref2$templateId = _ref2.templateId,
    templateId = _ref2$templateId === void 0 ? '' : _ref2$templateId,
    _ref2$onAccept = _ref2.onAccept,
    onAccept = _ref2$onAccept === void 0 ? function () {} : _ref2$onAccept,
    _ref2$onClose = _ref2.onClose,
    onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose;
  switch (openMode) {
    case 'Save':
      return /*#__PURE__*/jsx(EditTemplateConfirmationModal, {
        openMode: openMode,
        cadencesUsingTemplate: cadencesUsingTemplate,
        onAccept: onAccept,
        onClose: onClose
      });
    case 'Delete':
      return /*#__PURE__*/jsx(DeleteConfirmationModal, {
        openMode: openMode,
        templateId: templateId,
        onAccept: onAccept,
        onClose: onClose
      });
    case 'Discard':
      return /*#__PURE__*/jsx(DiscardConfirmationModal, {
        openMode: openMode,
        templateId: templateId,
        onAccept: onAccept,
        onClose: onClose
      });
    default:
      return null;
  }
}

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$7(arr, i) { return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$7(); }
function _nonIterableRest$7() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }
function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$7(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$7(arr) { if (Array.isArray(arr)) return arr; }
function getFocusPoint(focusedEditor, currentSelectedIndex) {
  return currentSelectedIndex !== 1 ? Editor.end(focusedEditor, []) : focusedEditor.selection;
}
var HandleTemplateHeader = function HandleTemplateHeader(_ref) {
  var onBack = _ref.onBack,
    handleSave = _ref.handleSave,
    viewSegmentation = _ref.viewSegmentation,
    switchView = _ref.switchView,
    isEditing = _ref.isEditing,
    isSnippet = _ref.isSnippet;
  var _useState = useState(false),
    _useState2 = _slicedToArray$7(_useState, 2),
    discardModalOpen = _useState2[0],
    setDiscardModalOpen = _useState2[1];
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$7.header,
      children: [/*#__PURE__*/jsx("div", {
        className: styles$7.formHeader,
        children: !viewSegmentation ? /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(Button, {
            iconLeft: "cross",
            size: "small",
            color: "tomato",
            onClick: function onClick() {
              return setDiscardModalOpen(true);
            },
            variant: "clear",
            uppercase: false,
            className: styles$7.noPadding,
            children: isEditing ? 'Discard changes' : 'Discard template'
          }), /*#__PURE__*/jsx(Button, {
            iconLeft: "save",
            size: "small",
            color: "purple",
            onClick: handleSave,
            uppercase: false,
            children: "Save"
          })]
        }) : /*#__PURE__*/jsx(Button, {
          iconLeft: "arrowLeft",
          size: "small",
          color: "purple",
          onClick: switchView,
          variant: "clear",
          uppercase: false,
          className: styles$7.noPadding,
          children: "Go back"
        })
      }), /*#__PURE__*/jsxs("div", {
        className: styles$7.headerText,
        children: [/*#__PURE__*/jsx(Text, {
          size: "m",
          weight: "bold",
          children: "".concat(isEditing ? 'Edit' : 'Save new', " ").concat(isSnippet ? 'snippet' : 'template')
        }), !viewSegmentation && /*#__PURE__*/jsx(Button, {
          variant: "clear",
          size: "small",
          uppercase: false,
          iconLeft: viewSegmentation ? 'noteAction' : 'sliders',
          onClick: switchView,
          color: "purple",
          className: styles$7.noPadding,
          children: "Change segmentation"
        })]
      })]
    }), /*#__PURE__*/jsx(PlaybookConfirmationModal, {
      openMode: discardModalOpen && 'Discard',
      templateId: isEditing && 'templateId',
      onClose: function onClose() {
        return setDiscardModalOpen(false);
      },
      onAccept: onBack
    })]
  });
};
var HandleTemplate = function HandleTemplate(_ref2) {
  var accountId = _ref2.accountId,
    onBack = _ref2.onBack,
    template = _ref2.template,
    contextValues = _ref2.contextValues,
    mutateSnippets = _ref2.mutateSnippets,
    contextProps = _ref2.contextProps;
  var editorsRef = contextProps.editorsRef,
    editorsStored = contextProps.editorsStored,
    focusedRef = contextProps.focusedRef,
    updateFocusedIndex = contextProps.updateFocusedIndex;
  var isEditing = !!(template !== null && template !== void 0 && template.id);
  var isSnippet = (template === null || template === void 0 ? void 0 : template.type) === TEMPLATE_TYPES.SNIPPET;
  var defaultValues = _objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8({}, defaultTemplate), contextValues.stage === 'PROSPECTING' ? {
    stage: TemplateStage.Prospecting
  } : contextValues), template), {}, {
    segmentationValues: parseSegmentationValues(template.segmentationValues, template.stage)
  });
  var formMethods = useForm({
    defaultValues: defaultValues
  });
  var handleSubmit = formMethods.handleSubmit,
    setError = formMethods.setError,
    reset = formMethods.reset;
  var _useMessagingTemplate = useMessagingTemplate(template === null || template === void 0 ? void 0 : template.id),
    saveMessagingTemplate = _useMessagingTemplate.saveMessagingTemplate;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray$7(_useState3, 2),
    viewSegmentation = _useState4[0],
    setViewSegmentation = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray$7(_useState5, 2),
    isOpenModal = _useState6[0],
    setIsOpenModal = _useState6[1];
  var attachedFilesFunctions = useAttachedFiles();
  var attachedFiles = attachedFilesFunctions.attachedFiles,
    syncAttachments = attachedFilesFunctions.syncAttachments;
  var _useCadencesUsingTemp = useCadencesUsingTemplate(template === null || template === void 0 ? void 0 : template.id),
    cadencesUsingTemplate = _useCadencesUsingTemp.cadencesUsingTemplate;
  useEffect(function () {
    var _template$mediaFiles;
    reset(defaultValues);
    // sync attachments from minimized template
    if ((template === null || template === void 0 ? void 0 : (_template$mediaFiles = template.mediaFiles) === null || _template$mediaFiles === void 0 ? void 0 : _template$mediaFiles.length) > 0) {
      syncAttachments(template.mediaFiles);
    }
  }, [template]);
  function switchView() {
    setViewSegmentation(!viewSegmentation);
  }
  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var isNameEmpty, _data$name$0$children, _template$type, newMessagingTemplate, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isNameEmpty = !data || !data.name || !data.name[0].children || data.name[0].children[0].text === '';
              if (!isNameEmpty) {
                _context.next = 6;
                break;
              }
              switchView();
              setError('name', {
                type: 'required',
                message: 'A name for the template is required'
              });
              _context.next = 11;
              break;
            case 6:
              newMessagingTemplate = _objectSpread$8(_objectSpread$8(_objectSpread$8(_objectSpread$8({}, data), template !== null && template !== void 0 && template.id ? {
                id: template === null || template === void 0 ? void 0 : template.id
              } : {}), {}, {
                name: (_data$name$0$children = data.name[0].children) === null || _data$name$0$children === void 0 ? void 0 : _data$name$0$children[0].text,
                subject: data.subject ? JSON.stringify(data.subject) : ''
              }, data.shortcut ? {
                shortcut: data.shortcut
              } : {}), {}, {
                content: data.content ? JSON.stringify(data.content) : '',
                segmentationValues: getSegmentationValuesToSendToDB(data.segmentationValues, data.stage),
                visibility: data.visibility,
                type: (_template$type = template === null || template === void 0 ? void 0 : template.type) !== null && _template$type !== void 0 ? _template$type : TEMPLATE_TYPES.EMAIL,
                format: 'AST',
                mediaFileIds: (attachedFiles === null || attachedFiles === void 0 ? void 0 : attachedFiles.length) > 0 ? attachedFiles.map(function (file) {
                  return file.id;
                }) : []
              });
              _context.next = 9;
              return saveMessagingTemplate(newMessagingTemplate);
            case 9:
              res = _context.sent;
              if (res === 409) {
                createToast({
                  type: 'error',
                  message: 'A template with the same name already exists, please try with a new one'
                });
              } else {
                createToast({
                  type: 'success',
                  message: 'Template saved successfully'
                });
                onBack();
                window.dispatchEvent(new CustomEvent('PLAYBOOK_FEED'));
                mutateSnippets();
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  function handleConfirm() {
    handleSubmit(function (data) {
      return onSubmit(data);
    }, function (err) {
      return console.log('error', err);
    })();
  }
  function handleSave() {
    if (isEditing && cadencesUsingTemplate && cadencesUsingTemplate.length) {
      setIsOpenModal(true);
    } else {
      handleConfirm();
    }
  }
  function handleEvent(e) {
    if (e.key === 'Tab') {
      updateFocusedIndex();
      e.stopPropagation();
      var focusedEditor = editorsRef.current[focusedRef.current];
      if ((focusedEditor === null || focusedEditor === void 0 ? void 0 : focusedEditor.id) === 'shortcutInput') {
        var shortcutInput = document.getElementById('shortcutInput');
        shortcutInput === null || shortcutInput === void 0 ? void 0 : shortcutInput.focus();
      } else {
        var focusPoint = getFocusPoint(focusedEditor, focusedRef.current);
        setTimeout(function () {
          return focusEditor(focusedEditor, focusPoint);
        }, 0);
      }
    }
  }
  var memoedFunction = useCallback(handleEvent, [editorsStored]);
  useEffect(function () {
    if (editorsStored) {
      window.addEventListener('keydown', memoedFunction, true);
      return function () {
        window.removeEventListener('keydown', memoedFunction, true);
      };
    }
  }, [editorsStored]);
  return /*#__PURE__*/jsxs("div", {
    className: styles$7.container,
    children: [/*#__PURE__*/jsxs(FormProvider, _objectSpread$8(_objectSpread$8({}, formMethods), {}, {
      children: [/*#__PURE__*/jsx(HandleTemplateHeader, {
        onBack: onBack,
        handleSave: handleSave,
        viewSegmentation: viewSegmentation,
        switchView: switchView,
        isEditing: isEditing,
        isSnippet: isSnippet
      }), viewSegmentation ? /*#__PURE__*/jsx(SegmentationForm, {
        canBeBattlecard: isSnippet
      }) : /*#__PURE__*/jsx(TemplateForm, _objectSpread$8({
        accountId: accountId,
        template: template,
        contextProps: contextProps
      }, attachedFilesFunctions))]
    })), /*#__PURE__*/jsx(PlaybookConfirmationModal, {
      openMode: isOpenModal && 'Save',
      onAccept: handleConfirm,
      onClose: function onClose() {
        return setIsOpenModal(false);
      },
      cadencesUsingTemplate: cadencesUsingTemplate
    })]
  });
};

var css_248z$4 = ".playbookFeed-module_container__KPrQw {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n/* Linkedin overrides */\n.playbookFeed-module_container__KPrQw input {\n  margin: 0 !important;\n  box-shadow: none !important;\n  height: auto !important;\n  border: none !important;\n  width: 100%;\n}\n\n.playbookFeed-module_header_container__41WXx {\n  background-color: var(--verySoftPurple);\n  padding: 15px 15px 9px 15px;\n  margin-bottom: 6px;\n}\n\n.playbookFeed-module_noBorder__xqQwA > input {\n  box-shadow: none;\n}\n\n.playbookFeed-module_cards_container__0IAxb {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n  overscroll-behavior-y: contain;\n}\n.playbookFeed-module_cards_spinner__F4n96 {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n.playbookFeed-module_title_container__MCIFJ {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.playbookFeed-module_title_container__MCIFJ > p {\n  font-size: 18px;\n}\n\n.playbookFeed-module_tabs_container__oryzS {\n  display: flex;\n  justify-content: center;\n  margin-top: 6px;\n}\n\n.playbookFeed-module_see_tabs_container__jsfm1 {\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 6px;\n}\n\n.playbookFeed-module_see_tabs_item__AScHL {\n  display: flex;\n  width: 160px;\n  padding: 12px 0;\n  justify-content: center;\n  gap: 3px;\n  border-top: 1px solid transparent;\n  align-items: center;\n  cursor: pointer;\n}\n\n.playbookFeed-module_see_tabs_item__AScHL > p {\n  font-size: 13px;\n}\n\n.playbookFeed-module_tab_container__HjPn5 {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 8px;\n  cursor: pointer;\n  border-top: 1px solid transparent;\n  width: 65px;\n}\n\n.playbookFeed-module_templateCardButtons__90TOf {\n  background-color: var(--white);\n  display: flex;\n  flex-direction: row;\n  align-self: end;\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  padding: 4px;\n}\n\n.playbookFeed-module_qqHoverButtons__v44SN {\n  position: absolute;\n  top: 10px;\n  right: 8px;\n  padding: 4px;\n}\n\n.playbookFeed-module_headerTitle__R69um {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.playbookFeed-module_templateSection__R7kPw {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 8px 0;\n}\n\n.playbookFeed-module_templateSectionSidePeek__sW0iM {\n  padding: 12px 24px 8px;\n}\n\n.playbookFeed-module_smartTemplateSection__pPDZ7 {\n  padding: 16px 24px 0;\n}\n\n.playbookFeed-module_headerTitle__R69um > div[class^='SmallInput'] {\n  width: 155px !important;\n  border: 0;\n}\n\n.playbookFeed-module_headerTitle__R69um > div[class^='SmallInput'] > div > input {\n  color: var(--purple);\n  background-color: transparent;\n}\n\n.playbookFeed-module_headerTitle__R69um > div[class^='SmallInput'] > div {\n  border: 1px solid var(--lightPurple);\n  background-color: var(--white);\n}\n\n.playbookFeed-module_spinner__IiMCP {\n  width: 100%;\n  height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.playbookFeed-module_segmentedFor__qnFyW {\n  flex-shrink: 0;\n  flex-grow: 0;\n  margin-right: 4px;\n}\n\n.playbookFeed-module_selectedValuesNames__-yTyf {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.playbookFeed-module_buttonText__pJ4t8 {\n  display: flex;\n  overflow: hidden;\n}\n\n.playbookFeed-module_buttonContent__qeSCf {\n  display: flex;\n  justify-content: space-between;\n  overflow: hidden;\n}\n\n.playbookFeed-module_sectionName__gF9D9 {\n  padding-left: 12px;\n}\n\n.playbookFeed-module_selectorWrapper__sX8qP {\n  display: flex;\n  justify-content: center;\n}\n\n.playbookFeed-module_contentWrapper__FgkhZ {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.playbookFeed-module_contentWrapper__FgkhZ > Button {\n  padding: 4px 6px;\n}\n\n.playbookFeed-module_contentWrapper__FgkhZ svg {\n  flex-shrink: 0;\n}\n.playbookFeed-module_buttonButtons__oLaRn {\n  display: flex;\n}\n\n.playbookFeed-module_buttonButtons__oLaRn > button {\n  margin-top: -1px;\n}\n\n.playbookFeed-module_title_sidePeek__1ddco {\n  font-size: 13px;\n}\n";
var styles$4 = {"container":"playbookFeed-module_container__KPrQw","header_container":"playbookFeed-module_header_container__41WXx","noBorder":"playbookFeed-module_noBorder__xqQwA","cards_container":"playbookFeed-module_cards_container__0IAxb","cards_spinner":"playbookFeed-module_cards_spinner__F4n96","title_container":"playbookFeed-module_title_container__MCIFJ","tabs_container":"playbookFeed-module_tabs_container__oryzS","see_tabs_container":"playbookFeed-module_see_tabs_container__jsfm1","see_tabs_item":"playbookFeed-module_see_tabs_item__AScHL","tab_container":"playbookFeed-module_tab_container__HjPn5","templateCardButtons":"playbookFeed-module_templateCardButtons__90TOf","qqHoverButtons":"playbookFeed-module_qqHoverButtons__v44SN","headerTitle":"playbookFeed-module_headerTitle__R69um","templateSection":"playbookFeed-module_templateSection__R7kPw","templateSectionSidePeek":"playbookFeed-module_templateSectionSidePeek__sW0iM","smartTemplateSection":"playbookFeed-module_smartTemplateSection__pPDZ7","spinner":"playbookFeed-module_spinner__IiMCP","segmentedFor":"playbookFeed-module_segmentedFor__qnFyW","selectedValuesNames":"playbookFeed-module_selectedValuesNames__-yTyf","buttonText":"playbookFeed-module_buttonText__pJ4t8","buttonContent":"playbookFeed-module_buttonContent__qeSCf","sectionName":"playbookFeed-module_sectionName__gF9D9","selectorWrapper":"playbookFeed-module_selectorWrapper__sX8qP","contentWrapper":"playbookFeed-module_contentWrapper__FgkhZ","buttonButtons":"playbookFeed-module_buttonButtons__oLaRn","title_sidePeek":"playbookFeed-module_title_sidePeek__1ddco"};
styleInject(css_248z$4);

var useIsTemplateOwner = function useIsTemplateOwner(template) {
  var _settings$user, _settings$user$roles, _settings$user2, _settings$user2$roles, _settings$user3;
  var _useActiveUserSetting = useActiveUserSettings(),
    settings = _useActiveUserSetting.settings;
  var isAdmin = (settings === null || settings === void 0 ? void 0 : (_settings$user = settings.user) === null || _settings$user === void 0 ? void 0 : (_settings$user$roles = _settings$user.roles) === null || _settings$user$roles === void 0 ? void 0 : _settings$user$roles.includes(UserRole.GLOBAL_ADMIN)) || (settings === null || settings === void 0 ? void 0 : (_settings$user2 = settings.user) === null || _settings$user2 === void 0 ? void 0 : (_settings$user2$roles = _settings$user2.roles) === null || _settings$user2$roles === void 0 ? void 0 : _settings$user2$roles.includes(UserRole.ACCOUNT_ADMIN));
  return (settings === null || settings === void 0 ? void 0 : (_settings$user3 = settings.user) === null || _settings$user3 === void 0 ? void 0 : _settings$user3.id) === (template === null || template === void 0 ? void 0 : template.createdBy) || !(template !== null && template !== void 0 && template.createdBy) || isAdmin;
};

var css_248z$3 = ".playbookCard-module_container__LsClD {\n  border: 1px solid var(--veryLightBloobirds);\n  display: flex;\n  flex-direction: column;\n  margin: 8px 8px 0 8px;\n  background-color: white;\n  transition: background-color 0.3s;\n  cursor: pointer;\n  box-shadow: 0 2px 4px 0 rgba(25, 145, 255, 0.0843);\n  border-radius: 4px;\n}\n.playbookCard-module_container__LsClD:hover {\n  transition: background-color 0.3s;\n  background-color: var(--verySoftPurple);\n}\n\n.playbookCard-module_containerSmartEmail__Vr5lM {\n  margin: 8px 24px 0 24px;\n}\n\n.playbookCard-module_containerSidePeek__YSrd- {\n  margin: 8px 24px;\n}\n\n.playbookCard-module_qq_container__3w-Wb {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin: 0 16px;\n}\n\n.playbookCard-module_container__LsClD:last-child {\n  margin-bottom: 16px;\n}\n\n.playbookCard-module_cardText__ztERv {\n  display: flex;\n  position: relative;\n  padding: 16px 16px 8px 8px;\n  white-space: break-spaces;\n  font-weight: bold;\n}\n\n.playbookCard-module_cardTextSidePeek__HE2Qf {\n  padding: 16px 16px 8px 16px;\n}\n\n.playbookCard-module_qq_cardText__Ylr8d {\n  display: flex;\n  overflow: hidden;\n  white-space: break-spaces;\n  font-weight: bold;\n  gap: 10px;\n}\n\n.playbookCard-module_cardText__ztERv > p,\n.playbookCard-module_qq_cardText__Ylr8d > p {\n  width: 100%;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.playbookCard-module_templateText__Uq2yu {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.playbookCard-module_templateText__Uq2yu * {\n  line-height: 20px;\n}\n\n.playbookCard-module_templateText__Uq2yu > p:first-child {\n  font-size: 14px;\n}\n\n.playbookCard-module_templateText__Uq2yu > p:nth-child(2) {\n  font-size: 13px;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.playbookCard-module_cardText__ztERv > svg {\n  margin-right: 10px;\n}\n\n.playbookCard-module_qq_cardContent__jRBry {\n  margin: 16px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.playbookCard-module_templateBody__DN6yN {\n  font-weight: normal;\n  display: inline;\n}\n\n.playbookCard-module_templateBody__DN6yN > div {\n  display: inline-block;\n}\n\n.playbookCard-module_templateBody__DN6yN > * > strong {\n  font-weight: normal;\n}\n\n.playbookCard-module_templateBody__DN6yN > br {\n  display: none;\n}\n\n.playbookCard-module_buttonsContainer__oQpCL {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n  gap: 8px;\n}\n\n.playbookCard-module_smartButtonsContainer__v-YsD {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 8px;\n  gap: 6px;\n  transition: gap 0.1s;\n}\n\n.playbookCard-module_container__LsClD:hover > .playbookCard-module_smartButtonsContainer__v-YsD {\n  gap: 3px;\n  transition: gap 0.1s;\n}\n\n.playbookCard-module_buttonContainer__6xxfQ {\n  display: flex;\n}\n\n.playbookCard-module_container__LsClD > .playbookCard-module_buttonsContainer__oQpCL button {\n  padding-left: 3px;\n  padding-right: 0;\n  width: 24px;\n  transition: width 0.1s;\n}\n\n.playbookCard-module_container__LsClD:hover > .playbookCard-module_buttonsContainer__oQpCL button {\n  transition: width 0.1s;\n  padding-left: 12px;\n  width: auto;\n  padding-right: 12px;\n}\n\n.playbookCard-module_container__LsClD > .playbookCard-module_smartButtonsContainer__v-YsD button {\n  padding-left: 3px;\n  padding-right: 0;\n  width: 24px;\n  transition: width 0.1s;\n}\n\n.playbookCard-module_container__LsClD:hover > .playbookCard-module_smartButtonsContainer__v-YsD button {\n  transition: width 0.1s;\n  padding-left: 8px;\n  width: auto;\n  padding-right: 12px;\n}\n\n.playbookCard-module_container__LsClD:hover > .playbookCard-module_smartButtonsContainer__v-YsD > button:first-child {\n  padding-left: 14px;\n}\n\n.playbookCard-module_container__LsClD:hover > .playbookCard-module_smartButtonsContainer__v-YsD > button:last-child {\n  padding-left: 4px;\n}\n\n.playbookCard-module_official_banner__BPuI5 {\n  position: absolute;\n  top: -4px;\n  left: 10px;\n}\n\n.playbookCard-module_leftIcons_container__vr0LP {\n  display: flex;\n  flex-direction: column;\n  margin-right: 6px;\n}\n";
var styles$3 = {"container":"playbookCard-module_container__LsClD","containerSmartEmail":"playbookCard-module_containerSmartEmail__Vr5lM","containerSidePeek":"playbookCard-module_containerSidePeek__YSrd-","qq_container":"playbookCard-module_qq_container__3w-Wb","cardText":"playbookCard-module_cardText__ztERv","cardTextSidePeek":"playbookCard-module_cardTextSidePeek__HE2Qf","qq_cardText":"playbookCard-module_qq_cardText__Ylr8d","templateText":"playbookCard-module_templateText__Uq2yu","qq_cardContent":"playbookCard-module_qq_cardContent__jRBry","templateBody":"playbookCard-module_templateBody__DN6yN","buttonsContainer":"playbookCard-module_buttonsContainer__oQpCL","smartButtonsContainer":"playbookCard-module_smartButtonsContainer__v-YsD","buttonContainer":"playbookCard-module_buttonContainer__6xxfQ","official_banner":"playbookCard-module_official_banner__BPuI5","leftIcons_container":"playbookCard-module_leftIcons_container__vr0LP"};
styleInject(css_248z$3);

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$7(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$6(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$6(); }
function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }
function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$6(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }
function getTabIcon(tabSelected) {
  switch (tabSelected) {
    case PlaybookTab$1.SNIPPETS:
      return 'snippet';
    case PlaybookTab$1.PITCHES:
      return 'chat';
    case PlaybookTab$1.EMAILS:
      return 'mail';
    case PlaybookTab$1.LINKEDIN:
      return 'linkedin';
    case PlaybookTab$1.QQS:
      return 'chatSupport';
    default:
      return 'questionCircle';
  }
}
var getButtonProps = function getButtonProps(tabSelected, disabled) {
  switch (tabSelected) {
    case PlaybookTab$1.PITCHES:
      return {
        iconLeft: 'eye',
        onClick: function onClick() {},
        text: 'View'
      };
    case PlaybookTab$1.EMAILS:
      return {
        iconLeft: 'send',
        onClick: function onClick() {},
        text: 'Send',
        disabled: disabled
      };
    case PlaybookTab$1.SNIPPETS:
      return {
        iconLeft: 'fileInsert',
        onClick: function onClick() {},
        text: 'Insert',
        disabled: disabled
      };
    case PlaybookTab$1.LINKEDIN:
      return {
        iconLeft: 'linkedin',
        onClick: function onClick() {},
        text: 'Send',
        disabled: disabled
      };
  }
};
var standardButtonProps = {
  size: 'small',
  uppercase: false,
  variant: 'secondary',
  color: 'purple'
};

//TODO: improve button props handling
var MessagingCard = function MessagingCard(_ref) {
  var _clsx, _buttonProps$, _buttonProps$2;
  var template = _ref.template,
    _onClick = _ref.onClick,
    tabSelected = _ref.tabSelected,
    isSmartEmail = _ref.isSmartEmail,
    buttonProps = _ref.buttonProps,
    templateFunctions = _ref.templateFunctions,
    actionsDisabled = _ref.actionsDisabled,
    sidePeekEnabled = _ref.sidePeekEnabled;
  var _useHover = useHover(),
    _useHover2 = _slicedToArray$6(_useHover, 2),
    ref = _useHover2[0],
    isHovering = _useHover2[1];
  var tabIcon = tabSelected && getTabIcon(tabSelected);
  var lastButtonProps = getButtonProps(tabSelected, actionsDisabled);
  var isPitches = tabSelected === PlaybookTab$1.PITCHES;
  var isSnippet = tabSelected === PlaybookTab$1.SNIPPETS;
  var isOwner = useIsTemplateOwner(template);
  var containerClasses = clsx(styles$3.container, (_clsx = {}, _defineProperty$7(_clsx, styles$3.containerSidePeek, sidePeekEnabled), _defineProperty$7(_clsx, styles$3.containerSmartEmail, isSmartEmail), _clsx));
  var cardClasses = clsx(styles$3.cardText, _defineProperty$7({}, styles$3.cardTextSidePeek, sidePeekEnabled));
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: containerClasses,
    onClick: function onClick() {
      return _onClick(template);
    },
    children: [/*#__PURE__*/jsxs("div", {
      className: cardClasses,
      children: [template.isOfficial && /*#__PURE__*/jsx("div", {
        className: styles$3.official_banner,
        children: /*#__PURE__*/jsx(Tooltip, {
          title: "Official template",
          position: "top",
          children: /*#__PURE__*/jsx(Icon, {
            name: "bookmark_big",
            color: "purple",
            size: 20
          })
        })
      }), /*#__PURE__*/jsxs("div", {
        className: styles$3.leftIcons_container,
        children: [tabIcon && /*#__PURE__*/jsx(Icon, {
          name: tabIcon,
          color: "lightPurple",
          size: 24
        }), (isPitches || isSnippet) && template.isBattlecard && /*#__PURE__*/jsx(Tooltip, {
          title: "Battlecard",
          position: "top",
          children: /*#__PURE__*/jsx(Icon, {
            name: "battlecards",
            color: "purple"
          })
        })]
      }), sidePeekEnabled ? /*#__PURE__*/jsxs("div", {
        className: styles$3.templateText,
        children: [/*#__PURE__*/jsx(Text, {
          size: "xs",
          weight: "bold",
          children: template === null || template === void 0 ? void 0 : template.name
        }), /*#__PURE__*/jsx(Text, {
          size: "xs",
          children: /*#__PURE__*/jsx("div", {
            className: styles$3.templateBody,
            children: removeHtmlTags(template === null || template === void 0 ? void 0 : template.previewContent)
          })
        })]
      }) : /*#__PURE__*/jsxs(Text, {
        size: "xs",
        weight: "bold",
        children: [template === null || template === void 0 ? void 0 : template.name, ' ', /*#__PURE__*/jsx("div", {
          className: styles$3.templateBody,
          children: removeHtmlTags(template === null || template === void 0 ? void 0 : template.previewContent)
        })]
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: isSmartEmail ? styles$3.smartButtonsContainer : styles$3.buttonsContainer,
      children: [/*#__PURE__*/jsx(Tooltip, {
        title: !isOwner && 'Only the Owner or an Admin can edit this template',
        position: 'top',
        children: /*#__PURE__*/jsx("div", {
          className: styles$3.buttonContainer,
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          children: /*#__PURE__*/jsx(Button, _objectSpread$7(_objectSpread$7({
            iconLeft: "edit"
          }, isOwner ? standardButtonProps : _objectSpread$7(_objectSpread$7({}, standardButtonProps), {}, {
            color: 'softPeanut'
          })), {}, {
            onClick: (_buttonProps$ = buttonProps[0]) === null || _buttonProps$ === void 0 ? void 0 : _buttonProps$.onClick,
            disabled: !isOwner,
            children: isHovering && 'Edit'
          }))
        })
      }), /*#__PURE__*/jsx(Button, _objectSpread$7(_objectSpread$7(_objectSpread$7({
        iconLeft: "eye"
      }, standardButtonProps), isPitches && {
        variant: 'primary'
      }), {}, {
        children: isHovering && 'View'
      })), !isPitches && !isSmartEmail && /*#__PURE__*/jsx(Tooltip, {
        title: actionsDisabled && 'You don’t have permissions required to perform this action',
        position: "top",
        children: /*#__PURE__*/jsx(Button, _objectSpread$7(_objectSpread$7(_objectSpread$7({}, standardButtonProps), {}, {
          variant: "primary"
        }, lastButtonProps), {}, {
          onClick: (_buttonProps$2 = buttonProps[1]) === null || _buttonProps$2 === void 0 ? void 0 : _buttonProps$2.onClick,
          children: isHovering && lastButtonProps.text
        }))
      }), isSmartEmail && /*#__PURE__*/jsxs(Fragment, {
        children: [isSnippet && /*#__PURE__*/jsx(Button, _objectSpread$7(_objectSpread$7({}, standardButtonProps), {}, {
          iconLeft: "fileInsert",
          variant: isSnippet ? 'primary' : 'secondary',
          onClick: function onClick(e) {
            e.stopPropagation();
            templateFunctions.insertTemplate(template);
          },
          children: isHovering && 'Insert'
        })), !isSnippet && /*#__PURE__*/jsx(Button, _objectSpread$7(_objectSpread$7({}, standardButtonProps), {}, {
          /* @ts-ignore */
          iconLeft: "sendEmailInvitation",
          variant: "primary",
          onClick: function onClick(e) {
            e.stopPropagation();
            templateFunctions.replaceTemplate(template);
          },
          children: isHovering && 'Use'
        }))]
      })]
    })]
  });
};
var QQsCard = function QQsCard(_ref2) {
  var qq = _ref2.template,
    tabSelected = _ref2.tabSelected,
    onUpdateQQ = _ref2.onUpdateQQ,
    QQValue = _ref2.QQValue,
    refreshActiveBobject = _ref2.refreshActiveBobject,
    actionsDisabled = _ref2.actionsDisabled;
  var tabIcon = tabSelected && getTabIcon(tabSelected);
  //@ts-ignore
  var type = qq.type,
    disabled = qq.disabled,
    question = qq.question,
    answers = qq.answers;
  var _useState = useState(QQValue),
    _useState2 = _slicedToArray$6(_useState, 2),
    internalValue = _useState2[0],
    setInternalValue = _useState2[1];
  var isGlobalPicklist = (type === null || type === void 0 ? void 0 : type.toString()) === QQ_TYPES.GLOBAL_PICKLIST;
  var isMultiGlobalPicklist = (type === null || type === void 0 ? void 0 : type.toString()) === QQ_TYPES.MULTI_GLOBAL_PICKLIST;
  var isText = (type === null || type === void 0 ? void 0 : type.toString()) === QQ_TYPES.TEXT;
  function handleChange(value) {
    var newQQData = _defineProperty$7({}, qq.id, value || internalValue);
    onUpdateQQ(newQQData);
    refreshActiveBobject();
  }
  return /*#__PURE__*/jsx("div", {
    className: styles$3.qq_container,
    children: /*#__PURE__*/jsxs("div", {
      className: styles$3.qq_cardContent,
      children: [/*#__PURE__*/jsxs("div", {
        className: styles$3.qq_cardText,
        children: [tabIcon && /*#__PURE__*/jsx(Icon, {
          name: tabIcon,
          color: "softPeanut",
          size: 24
        }), /*#__PURE__*/jsx(Text, {
          size: "s",
          weight: "bold",
          children: question
        })]
      }), isText && /*#__PURE__*/jsx(Input, {
        onBlur: function onBlur() {
          return handleChange();
        },
        disabled: disabled || actionsDisabled,
        width: "100%",
        size: "small",
        borderless: false,
        value: internalValue,
        onChange: setInternalValue,
        placeholder: "None"
      }), isGlobalPicklist && /*#__PURE__*/jsxs(Select, {
        placeholder: "Select...",
        disabled: disabled || actionsDisabled,
        borderless: false,
        width: "100%",
        size: "small",
        value: internalValue,
        onChange: function onChange(newValue) {
          setInternalValue(newValue);
          handleChange(newValue);
        },
        autocomplete: answers.length > 6,
        children: [/*#__PURE__*/jsx(Item, {
          value: "none",
          children: "None"
        }), answers.map(function (answer) {
          return /*#__PURE__*/jsx(Item, {
            hidden: !answer.enabled,
            value: answer.id,
            label: answer.value,
            children: answer.value
          }, answer.id);
        })]
      }), isMultiGlobalPicklist && /*#__PURE__*/jsxs(MultiSelect, {
        autocomplete: answers.length > 6,
        size: "small",
        value: internalValue,
        onChange: setInternalValue,
        onClose: function onClose() {
          handleChange();
        },
        width: "100%",
        borderless: false,
        selectAllOption: true,
        placeholder: "Select...",
        disabled: disabled || actionsDisabled,
        children: [/*#__PURE__*/jsx(CheckItem, {
          value: "",
          children: "None"
        }), answers.map(function (answer) {
          return /*#__PURE__*/jsx(CheckItem, {
            dataTest: answer.value,
            value: answer.id,
            label: answer.value,
            children: answer.value
          }, answer.value);
        })]
      })]
    })
  });
};

var baseUrls$1 = {
  production: 'https://app.bloobirds.com',
  development: 'https://app.dev-bloobirds.com',
  staging: 'https://app.staging-bloobirds.com'
};
function getTemplateTypeButtons(_ref) {
  var template = _ref.template,
    tabSelected = _ref.tabSelected,
    linkedInURL = _ref.linkedInURL,
    handleEmailModal = _ref.handleEmailModal,
    _ref$isSEE = _ref.isSEE,
    isSEE = _ref$isSEE === void 0 ? false : _ref$isSEE,
    userCanEdit = _ref.userCanEdit,
    editTemplate = _ref.editTemplate;
  var url = generateTemplateURL(template.id, tabSelected, linkedInURL, userCanEdit);
  switch (tabSelected) {
    case PlaybookTab$1.PITCHES:
      return [{
        tooltipText: 'Edit in Bloobirds',
        buttonText: 'Edit',
        name: 'edit',
        onClick: editTemplate ? function () {
          return editTemplate(template);
        } : function (e) {
          e.stopPropagation();
          window.open(url[0]);
        }
      }];
    case PlaybookTab$1.SNIPPETS:
      return [{
        tooltipText: 'Edit',
        name: 'edit',
        onClick: editTemplate ? function (e) {
          e.stopPropagation();
          editTemplate(template);
        } : function (e) {
          e.stopPropagation();
          window.open(url[0]);
        }
      }, !isSEE && {
        tooltipText: 'Send email',
        buttonText: 'Send',
        name: 'send',
        onClick: function onClick(e) {
          e.stopPropagation();
          handleEmailModal(template);
        },
        disabled: !userCanEdit
      }];
    case PlaybookTab$1.EMAILS:
      return [{
        tooltipText: 'Edit',
        name: 'edit',
        onClick: editTemplate ? function (e) {
          e.stopPropagation();
          editTemplate(template);
        } : function (e) {
          e.stopPropagation();
          window.open(url[0]);
        }
      }, !isSEE && {
        tooltipText: 'Send email',
        buttonText: 'Send',
        name: 'send',
        onClick: function onClick(e) {
          e.stopPropagation();
          handleEmailModal(template);
        },
        disabled: !userCanEdit
      }];
    case PlaybookTab$1.LINKEDIN:
      return [{
        tooltipText: 'Edit in Bloobirds',
        name: 'edit',
        onClick: function onClick(e) {
          e.stopPropagation();
          window.open(url[0]);
        }
      }, {
        tooltipText: 'Open in LinkedIn',
        buttonText: 'Open in LinkedIn',
        name: 'linkedin',
        onClick: function onClick(e) {
          e.stopPropagation();
          window.open(url[1]);
        },
        disabled: !userCanEdit
      }];
    default:
      return [];
  }
}
function generateTemplateURL(id, tabSelected, linkedInURL, userCanEdit) {
  var baseUrl = baseUrls$1["production"];
  switch (tabSelected) {
    case PlaybookTab$1.PITCHES:
      return userCanEdit ? ["".concat(baseUrl, "/app/playbook/messaging/pitch/form?mode=EDITION&id=").concat(id)] : ["".concat(baseUrl, "/app/playbook/messaging/pitch")];
    case PlaybookTab$1.EMAILS:
      return userCanEdit ? ["".concat(baseUrl, "/app/playbook/messaging/email/form?mode=EDITION&id=").concat(id)] : ["".concat(baseUrl, "/app/playbook/messaging/email")];
    case PlaybookTab$1.SNIPPETS:
      return userCanEdit ? ["".concat(baseUrl, "/app/playbook/messaging/snippet/form?mode=EDITION&id=").concat(id)] : ["".concat(baseUrl, "/app/playbook/messaging/snippet")];
    case PlaybookTab$1.LINKEDIN:
      return userCanEdit ? ["".concat(baseUrl, "/app/playbook/messaging/linkedin/form?mode=EDITION&id=").concat(id), linkedInURL] : ["".concat(baseUrl, "/app/playbook/messaging/linkedin"), linkedInURL];
    case PlaybookTab$1.QQS:
      return userCanEdit ? ["".concat(baseUrl, "/app/playbook/messaging/qq/form?mode=EDITION&id=").concat(id)] : ["".concat(baseUrl, "/app/playbook/messaging/qq")];
    default:
      return [''];
  }
}

var _excluded = ["tabSelected", "templateFunctions"];
var _templateTypes, _noResultsContent;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$5(); }
function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }
function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$5(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var templateTypes = (_templateTypes = {}, _defineProperty$6(_templateTypes, PlaybookTab$1.SNIPPETS, 'SNIPPET'), _defineProperty$6(_templateTypes, PlaybookTab$1.PITCHES, 'PITCH'), _defineProperty$6(_templateTypes, PlaybookTab$1.EMAILS, 'EMAIL'), _defineProperty$6(_templateTypes, PlaybookTab$1.LINKEDIN, 'LINKEDIN_MESSAGE'), _defineProperty$6(_templateTypes, PlaybookTab$1.QQS, 'QUALIFYING_QUESTION'), _templateTypes);
var noResultsContent = (_noResultsContent = {}, _defineProperty$6(_noResultsContent, PlaybookTab$1.SNIPPETS, {
  title: 'No snippet templates 💬️',
  description: 'Newly created snippets wil appear here',
  actionButton: /*#__PURE__*/jsx(Button, {
    size: "small",
    onClick: function onClick() {
      return window.open('https://app.bloobirds.com/app/playbook/messaging/snippet');
    },
    iconLeft: "plus",
    color: "lightPurple",
    children: "Add new snippet"
  })
}), _defineProperty$6(_noResultsContent, PlaybookTab$1.PITCHES, {
  title: 'No pitch templates 💬️',
  description: 'Newly created templates wil appear here',
  actionButton: /*#__PURE__*/jsx(Button, {
    size: "small",
    onClick: function onClick() {
      return window.open('https://app.bloobirds.com/app/playbook/messaging/pitch');
    },
    iconLeft: "plus",
    color: "lightPurple",
    children: "Add new template"
  })
}), _defineProperty$6(_noResultsContent, PlaybookTab$1.EMAILS, {
  title: 'No email templates ✉️',
  description: 'Newly created templates wil appear here',
  actionButton: /*#__PURE__*/jsx(Button, {
    size: "small",
    onClick: function onClick() {
      return window.open('https://app.bloobirds.com/app/playbook/messaging/email');
    },
    iconLeft: "plus",
    color: "lightPurple",
    children: "Add new template"
  })
}), _defineProperty$6(_noResultsContent, PlaybookTab$1.LINKEDIN, {
  title: 'No LinkedIn templates 📄️',
  description: 'Newly created templates wil appear here',
  actionButton: /*#__PURE__*/jsx(Button, {
    size: "small",
    onClick: function onClick() {
      return window.open('https://app.bloobirds.com/app/playbook/messaging/linkedin');
    },
    iconLeft: "plus",
    color: "lightPurple",
    children: "Add new template"
  })
}), _defineProperty$6(_noResultsContent, PlaybookTab$1.QQS, {
  title: 'No QQs created 💬 ',
  description: 'Configured QQs will appear here',
  actionButton: /*#__PURE__*/jsx(Button, {
    size: "small",
    onClick: function onClick() {
      return window.open('https://app.bloobirds.com/app/playbook/messaging/qq');
    },
    iconLeft: "plus",
    color: "lightPurple",
    children: "Add Qualifying Questions"
  })
}), _noResultsContent);
var MessagingContent = function MessagingContent(_ref) {
  var _settings$user, _settings$user2, _clsx, _clsx2;
  var templateFunctions = _ref.templateFunctions,
    isSmartEmail = _ref.isSmartEmail,
    onCardClicked = _ref.onCardClicked,
    activeBobject = _ref.activeBobject,
    segmentationValues = _ref.segmentationValues,
    visibilityFilters = _ref.visibilityFilters,
    searchValue = _ref.searchValue,
    tabSelected = _ref.tabSelected,
    isSalesStage = _ref.isSalesStage,
    actionsDisabled = _ref.actionsDisabled,
    _ref$contextData = _ref.contextData,
    company = _ref$contextData.company,
    leads = _ref$contextData.leads,
    sidePeekEnabled = _ref.sidePeekEnabled;
  var _useMessagingTemplate = useMessagingTemplates({
      stage: isSalesStage ? 'SALES' : 'PROSPECT',
      type: templateTypes[tabSelected],
      name: null,
      size: 200,
      page: 0,
      visibility: visibilityFilters !== null && visibilityFilters !== void 0 && visibilityFilters.onlyPrivate ? 'PRIVATE' : null,
      onlyMine: visibilityFilters === null || visibilityFilters === void 0 ? void 0 : visibilityFilters.onlyMine,
      onlyOfficials: visibilityFilters === null || visibilityFilters === void 0 ? void 0 : visibilityFilters.onlyOfficial,
      onlyBattlecards: visibilityFilters === null || visibilityFilters === void 0 ? void 0 : visibilityFilters.onlyBattlecards,
      segmentationValues: segmentationValues
    }),
    messagingTemplates = _useMessagingTemplate.messagingTemplates,
    isLoading = _useMessagingTemplate.isLoading;
  var isSnippets = tabSelected === PlaybookTab$1.SNIPPETS;
  var setEmailVariablesValues = useBaseSetEmailVariablesValues();
  var _useMinimizableModals = useMinimizableModals(),
    openMinimizableModal = _useMinimizableModals.openMinimizableModal;
  var _useActiveUserSetting = useActiveUserSettings(),
    settings = _useActiveUserSetting.settings;
  var userId = settings === null || settings === void 0 ? void 0 : (_settings$user = settings.user) === null || _settings$user === void 0 ? void 0 : _settings$user.id;
  var userRoles = settings === null || settings === void 0 ? void 0 : (_settings$user2 = settings.user) === null || _settings$user2 === void 0 ? void 0 : _settings$user2.roles;
  var isAdminUser = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes(UserRole.GLOBAL_ADMIN)) || (userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes(UserRole.ACCOUNT_ADMIN));
  var handleEmailModal = function handleEmailModal(template) {
    var _activeBobject$id, _leads$;
    var activeBobjectType = activeBobject === null || activeBobject === void 0 ? void 0 : (_activeBobject$id = activeBobject.id) === null || _activeBobject$id === void 0 ? void 0 : _activeBobject$id.typeName;
    setEmailVariablesValues({
      company: company === null || company === void 0 ? void 0 : company.rawBobject,
      lead: activeBobjectType === BobjectTypes.Lead ? activeBobject === null || activeBobject === void 0 ? void 0 : activeBobject.rawBobject : leads && ((_leads$ = leads[0]) === null || _leads$ === void 0 ? void 0 : _leads$.rawBobject),
      opportunity: undefined
    });
    openMinimizableModal({
      type: 'email',
      title: 'New Email',
      data: {
        template: {
          body: template === null || template === void 0 ? void 0 : template.content,
          subject: (template === null || template === void 0 ? void 0 : template.subject) || '',
          id: template === null || template === void 0 ? void 0 : template.id,
          format: template === null || template === void 0 ? void 0 : template.format,
          mediaFiles: template === null || template === void 0 ? void 0 : template.mediaFiles,
          name: (template === null || template === void 0 ? void 0 : template.name) || 'Untitled template'
        },
        mode: EMAIL_MODE.SEND,
        isBlankEmail: false,
        company: activeBobjectType === BobjectTypes.Company ? activeBobject : company,
        leads: leads,
        lead: activeBobjectType === BobjectTypes.Lead ? activeBobject : leads[0],
        pageBobjectType: activeBobject.id.typeName
      },
      onSave: function onSave() {
        window.dispatchEvent(new CustomEvent('ACTIVE_BOBJECT_UPDATED', {
          detail: {
            type: BobjectTypes.Activity
          }
        }));
      }
    });
  };
  function handleOnClick(template) {
    onCardClicked(template, tabSelected, handleEmailModal);
  }
  var selectedTabNoResultsContent = noResultsContent[tabSelected];
  var _useState = useState([]),
    _useState2 = _slicedToArray$5(_useState, 2),
    filteredMessagingTemplates = _useState2[0],
    setFilteredMessagingTemplates = _useState2[1];
  useEffect(function () {
    if (searchValue) {
      setFilteredMessagingTemplates(messagingTemplates === null || messagingTemplates === void 0 ? void 0 : messagingTemplates.filter(function (template) {
        var _template$name;
        return template === null || template === void 0 ? void 0 : (_template$name = template.name) === null || _template$name === void 0 ? void 0 : _template$name.toLowerCase().includes(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase());
      }));
    }
  }, [searchValue]);
  var messagingTemplatesToRender = searchValue ? filteredMessagingTemplates : messagingTemplates;
  var _partition = partition(messagingTemplatesToRender, function (template) {
      return (template === null || template === void 0 ? void 0 : template.createdBy) === userId;
    }),
    _partition2 = _slicedToArray$5(_partition, 2),
    myTemplates = _partition2[0],
    teamTemplates = _partition2[1];
  var areThereSegmentationFiltersApplied = segmentationValues && Object.keys(segmentationValues).length !== 0;
  var areThereVisibilityFiltersApplied = visibilityFilters && Object.values(visibilityFilters).some(function (v) {
    return !!v;
  });
  var noResults = (filteredMessagingTemplates === null || filteredMessagingTemplates === void 0 ? void 0 : filteredMessagingTemplates.length) === 0 && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.length) > 0 && (messagingTemplates === null || messagingTemplates === void 0 ? void 0 : messagingTemplates.length) > 0 || (messagingTemplates === null || messagingTemplates === void 0 ? void 0 : messagingTemplates.length) === 0 && (areThereSegmentationFiltersApplied || areThereVisibilityFiltersApplied);
  var noTemplates = (messagingTemplates === null || messagingTemplates === void 0 ? void 0 : messagingTemplates.length) === 0 && !areThereSegmentationFiltersApplied && !areThereVisibilityFiltersApplied;
  var renderTemplate = function renderTemplate(template) {
    var userIsOwner = userId === (template === null || template === void 0 ? void 0 : template.createdBy);
    var userCanEdit = userIsOwner || isAdminUser;
    var linkedInURL = getLinkedInURL(template === null || template === void 0 ? void 0 : template.id, company, leads, activeBobject);
    var buttonProps = getTemplateTypeButtons(_objectSpread$6({
      template: template,
      tabSelected: tabSelected,
      linkedInURL: linkedInURL,
      handleEmailModal: handleEmailModal,
      isSEE: isSmartEmail,
      userCanEdit: userCanEdit
    }, (templateFunctions === null || templateFunctions === void 0 ? void 0 : templateFunctions.editTemplate) && {
      editTemplate: templateFunctions === null || templateFunctions === void 0 ? void 0 : templateFunctions.editTemplate
    }));
    return /*#__PURE__*/jsx(MessagingCard, {
      template: template,
      onClick: handleOnClick,
      tabSelected: tabSelected,
      buttonProps: buttonProps,
      isSmartEmail: isSmartEmail,
      templateFunctions: templateFunctions,
      actionsDisabled: actionsDisabled,
      sidePeekEnabled: sidePeekEnabled
    }, template === null || template === void 0 ? void 0 : template.id);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [(myTemplates === null || myTemplates === void 0 ? void 0 : myTemplates.length) > 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs("div", {
        className: clsx(styles$4.templateSection, (_clsx = {}, _defineProperty$6(_clsx, styles$4.smartTemplateSection, isSmartEmail), _defineProperty$6(_clsx, styles$4.templateSectionSidePeek, sidePeekEnabled), _clsx)),
        children: [/*#__PURE__*/jsx(Icon, {
          color: "softPeanut",
          name: "person",
          size: 18
        }), /*#__PURE__*/jsx(Text, {
          size: 'xs',
          color: "softPeanut",
          weight: "bold",
          children: isSnippets ? 'My snippets' : 'My templates'
        })]
      }), myTemplates === null || myTemplates === void 0 ? void 0 : myTemplates.map(function (template) {
        return renderTemplate(template);
      })]
    }), (teamTemplates === null || teamTemplates === void 0 ? void 0 : teamTemplates.length) > 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs("div", {
        className: clsx(styles$4.templateSection, (_clsx2 = {}, _defineProperty$6(_clsx2, styles$4.smartTemplateSection, isSmartEmail), _defineProperty$6(_clsx2, styles$4.templateSectionSidePeek, sidePeekEnabled), _clsx2)),
        children: [/*#__PURE__*/jsx(Icon, {
          color: "softPeanut",
          name: "company",
          size: 20
        }), /*#__PURE__*/jsx(Text, {
          size: 'xs',
          color: "softPeanut",
          weight: "bold",
          children: "Team templates"
        })]
      }), teamTemplates === null || teamTemplates === void 0 ? void 0 : teamTemplates.map(function (template) {
        return renderTemplate(template);
      })]
    }), noResults && !isLoading && /*#__PURE__*/jsx(NoResultsPage, {
      title: "We didn't find any matches for your search \uD83D\uDD0D",
      description: "Modify your search and try again"
    }), noTemplates && !isLoading && /*#__PURE__*/jsx(NoResultsPage, {
      title: selectedTabNoResultsContent.title,
      description: selectedTabNoResultsContent.description,
      actionButton: selectedTabNoResultsContent.actionButton
    })]
  });
};
var QQsContent = function QQsContent(_ref2) {
  var activeBobject = _ref2.activeBobject,
    refreshActiveBobject = _ref2.refreshActiveBobject,
    segmentationValues = _ref2.segmentationValues,
    tabSelected = _ref2.tabSelected,
    isSalesStage = _ref2.isSalesStage,
    actionsDisabled = _ref2.actionsDisabled;
  var _useQualifyingQuestio = useQualifyingQuestions({
      enabled: true,
      stage: isSalesStage ? 'SALES' : 'PROSPECT',
      segmentationValues: segmentationValues,
      bobjectType: activeBobject.id.typeName
    }),
    qualifyingQuestions = _useQualifyingQuestio.qualifyingQuestions,
    isLoading = _useQualifyingQuestio.isLoading,
    updateQualifyingQuestionsValue = _useQualifyingQuestio.updateQualifyingQuestionsValue;
  var noResults = (qualifyingQuestions === null || qualifyingQuestions === void 0 ? void 0 : qualifyingQuestions.length) === 0 && Object.keys(segmentationValues).length !== 0;
  var noQQs = (qualifyingQuestions === null || qualifyingQuestions === void 0 ? void 0 : qualifyingQuestions.length) === 0 && Object.keys(segmentationValues).length === 0;
  var selectedTabNoResultsContent = noResultsContent[tabSelected];
  return /*#__PURE__*/jsxs(Fragment, {
    children: [(qualifyingQuestions === null || qualifyingQuestions === void 0 ? void 0 : qualifyingQuestions.length) > 0 && (qualifyingQuestions === null || qualifyingQuestions === void 0 ? void 0 : qualifyingQuestions.map(function (qq) {
      return /*#__PURE__*/jsx(QQsCard, {
        template: qq,
        QQValue: activeBobject !== null && activeBobject !== void 0 && activeBobject.rawBobject ? activeBobject === null || activeBobject === void 0 ? void 0 : activeBobject.rawBobject[qq === null || qq === void 0 ? void 0 : qq.id] : //@ts-ignore
        activeBobject === null || activeBobject === void 0 ? void 0 : activeBobject.raw[qq === null || qq === void 0 ? void 0 : qq.id],
        tabSelected: tabSelected,
        onUpdateQQ: function onUpdateQQ(value) {
          return updateQualifyingQuestionsValue(activeBobject, value);
        },
        refreshActiveBobject: refreshActiveBobject,
        actionsDisabled: actionsDisabled
      }, qq === null || qq === void 0 ? void 0 : qq.id);
    })), noResults && !isLoading && /*#__PURE__*/jsx(NoResultsPage, {
      title: "We didn't find any matches for your search \uD83D\uDD0D",
      description: "Modify your search and try again"
    }), noQQs && !isLoading && /*#__PURE__*/jsx(NoResultsPage, {
      title: selectedTabNoResultsContent.title,
      description: selectedTabNoResultsContent.description,
      actionButton: selectedTabNoResultsContent.actionButton
    })]
  });
};
var TabContent = function TabContent(_ref3) {
  var tabSelected = _ref3.tabSelected,
    templateFunctions = _ref3.templateFunctions,
    props = _objectWithoutProperties(_ref3, _excluded);
  switch (tabSelected) {
    case PlaybookTab$1.LINKEDIN:
    case PlaybookTab$1.EMAILS:
    case PlaybookTab$1.PITCHES:
    case PlaybookTab$1.SNIPPETS:
      if (props.isSmartEmail) {
        return /*#__PURE__*/jsx("div", {
          className: styles$4.cards_container,
          children: /*#__PURE__*/jsx(MessagingContent, _objectSpread$6({
            tabSelected: tabSelected,
            templateFunctions: templateFunctions
          }, props))
        });
      }
      return /*#__PURE__*/jsx(MessagingContent, _objectSpread$6({
        tabSelected: tabSelected
      }, props));
    case PlaybookTab$1.QQS:
      return /*#__PURE__*/jsx(QQsContent, _objectSpread$6({
        tabSelected: tabSelected
      }, props));
  }
};

var PlaybookTab;
(function (PlaybookTab) {
  PlaybookTab["SNIPPETS"] = "Snippets";
  PlaybookTab["PITCHES"] = "Pitches";
  PlaybookTab["EMAILS"] = "Emails";
  PlaybookTab["LINKEDIN"] = "LinkedIn";
  PlaybookTab["QQS"] = "QQs";
})(PlaybookTab || (PlaybookTab = {}));

function getEnvironment(isSmartEmail, isDialer) {
  if (isSmartEmail) {
    return 'isSmartEmail';
  }
  if (isDialer) {
    return 'isDialer';
  }
  return 'isExtension';
}
var PlaybookTabs = function PlaybookTabs(_ref) {
  var isSmartEmail = _ref.isSmartEmail,
    isDialer = _ref.isDialer,
    hasSnippetsEnabled = _ref.hasSnippetsEnabled,
    tabSelected = _ref.tabSelected,
    handleChangeTab = _ref.handleChangeTab,
    sidePeekEnabled = _ref.sidePeekEnabled;
  var environment = getEnvironment(isSmartEmail, isDialer);
  switch (environment) {
    case 'isSmartEmail':
      return hasSnippetsEnabled ? /*#__PURE__*/jsxs("div", {
        className: styles$4.tabs_container,
        children: [/*#__PURE__*/jsx(PlaybookTabElement, {
          selected: tabSelected,
          name: PlaybookTab.EMAILS,
          icon: "mail",
          onClick: handleChangeTab,
          className: styles$4.see_tabs_item
        }), /*#__PURE__*/jsx(PlaybookTabElement, {
          selected: tabSelected,
          name: PlaybookTab.SNIPPETS,
          icon: "snippet",
          onClick: handleChangeTab,
          className: styles$4.see_tabs_item,
          dataTest: "playbook-tab-snippets-SEE"
        })]
      }) : null;
    case 'isExtension':
      return /*#__PURE__*/jsxs("div", {
        className: styles$4.tabs_container,
        children: [/*#__PURE__*/jsx(PlaybookTabElement, {
          selected: tabSelected,
          name: PlaybookTab.PITCHES,
          icon: "chat",
          onClick: handleChangeTab,
          sidePeekEnabled: sidePeekEnabled
        }), hasSnippetsEnabled && /*#__PURE__*/jsx(PlaybookTabElement, {
          selected: tabSelected,
          name: PlaybookTab.SNIPPETS,
          icon: "snippet",
          onClick: handleChangeTab,
          sidePeekEnabled: sidePeekEnabled
        }), /*#__PURE__*/jsx(PlaybookTabElement, {
          selected: tabSelected,
          name: PlaybookTab.EMAILS,
          icon: "mail",
          onClick: handleChangeTab,
          sidePeekEnabled: sidePeekEnabled
        }), /*#__PURE__*/jsx(PlaybookTabElement, {
          selected: tabSelected,
          name: PlaybookTab.LINKEDIN,
          icon: "linkedin",
          onClick: handleChangeTab,
          sidePeekEnabled: sidePeekEnabled
        }), /*#__PURE__*/jsx(PlaybookTabElement, {
          selected: tabSelected,
          name: PlaybookTab.QQS,
          icon: "chatSupport",
          onClick: handleChangeTab,
          sidePeekEnabled: sidePeekEnabled
        })]
      });
    case 'isDialer':
      return /*#__PURE__*/jsx(Fragment, {});
  }
};

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$4(arr); }
function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$4(); }
function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$4(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$5(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var getTemplateButtons = getTemplateTypeButtons;
var PlaybookTabElement = function PlaybookTabElement(props) {
  var name = props.name,
    icon = props.icon,
    _onClick = props.onClick,
    selected = props.selected,
    sidePeekEnabled = props.sidePeekEnabled,
    className = props.className,
    dataTest = props.dataTest;
  var isSelected = selected === name;
  return /*#__PURE__*/jsxs("div", _objectSpread$5(_objectSpread$5({
    className: clsx(className || styles$4.tab_container),
    onClick: function onClick() {
      if (_onClick) {
        _onClick(name);
      }
    }
  }, dataTest ? {
    'data-test': dataTest
  } : {}), {}, {
    children: [/*#__PURE__*/jsx(Icon, {
      name: icon,
      color: isSelected ? 'purple' : 'softPeanut',
      size: sidePeekEnabled ? 24 : 14
    }), /*#__PURE__*/jsx(Text, {
      size: "xs",
      color: isSelected ? 'purple' : 'softPeanut',
      weight: isSelected ? 'bold' : 'regular',
      className: sidePeekEnabled && styles$4.title_sidePeek,
      children: name
    })]
  }));
};

//TODO expose in higher level
var baseUrls = {
  production: 'https://app.bloobirds.com',
  development: 'https://app.dev-bloobirds.com',
  staging: 'https://app.staging-bloobirds.com'
};
var TemplateSearch = function TemplateSearch(_ref) {
  var setSearchValue = _ref.setSearchValue,
    defaultOpen = _ref.defaultOpen;
  var _useState = useState(defaultOpen),
    _useState2 = _slicedToArray$4(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return isOpen ? /*#__PURE__*/jsx(Input, {
    icon: "search",
    size: "small",
    onChange: setSearchValue,
    color: "verySoftPurple",
    placeholder: "Search templates",
    className: styles$4.noBorder
  }) : /*#__PURE__*/jsx(IconButton, {
    color: "purple",
    onClick: function onClick() {
      return setIsOpen(true);
    },
    name: "search",
    size: 20
  });
};
var PlaybookFeed = function PlaybookFeed(_ref2) {
  var accountId = _ref2.accountId,
    mainBobject = _ref2.mainBobject,
    isMainBobjectSalesStage = _ref2.isMainBobjectSalesStage,
    company = _ref2.company,
    leads = _ref2.leads,
    _ref2$isSmartEmail = _ref2.isSmartEmail,
    isSmartEmail = _ref2$isSmartEmail === void 0 ? false : _ref2$isSmartEmail,
    _ref2$isDialer = _ref2.isDialer,
    isDialer = _ref2$isDialer === void 0 ? false : _ref2$isDialer,
    _ref2$selectedTab = _ref2.selectedTab,
    selectedTab = _ref2$selectedTab === void 0 ? PlaybookTab$1.PITCHES : _ref2$selectedTab,
    _ref2$setSelectedTab = _ref2.setSelectedTab,
    setSelectedTab = _ref2$setSelectedTab === void 0 ? function () {} : _ref2$setSelectedTab,
    onCardClicked = _ref2.onCardClicked,
    refreshMainBobject = _ref2.refreshMainBobject,
    isFilterViewOpen = _ref2.isFilterViewOpen,
    toggleFilterView = _ref2.toggleFilterView,
    isSalesStage = _ref2.isSalesStage,
    segmentationFields = _ref2.segmentationFields,
    segmentationValues = _ref2.segmentationValues,
    visibilityFilters = _ref2.visibilityFilters,
    setFiltersContext = _ref2.setFiltersContext,
    templateFunctions = _ref2.templateFunctions,
    _ref2$actionsDisabled = _ref2.actionsDisabled,
    actionsDisabled = _ref2$actionsDisabled === void 0 ? false : _ref2$actionsDisabled,
    _ref2$sidePeekEnabled = _ref2.sidePeekEnabled,
    sidePeekEnabled = _ref2$sidePeekEnabled === void 0 ? false : _ref2$sidePeekEnabled;
  var hasSnippetsEnabled = useSnippetsEnabled(accountId);
  var _useState3 = useState(),
    _useState4 = _slicedToArray$4(_useState3, 2),
    searchValue = _useState4[0],
    setSearchValue = _useState4[1];
  var handleChangeTab = function handleChangeTab(tab) {
    setSelectedTab(tab);
    setFiltersContext({
      segmentationData: activeBobjectSegmentationValues,
      isSalesStage: isSalesStage,
      isFilterViewOpen: isFilterViewOpen,
      visibilityFilters: visibilityFilters,
      shouldShowBattlecards: [PlaybookTab$1.PITCHES, PlaybookTab$1.SNIPPETS].includes(tab),
      shouldShowVisibilityFilters: tab !== PlaybookTab$1.QQS
    });
  };
  var _usePlaybook = usePlaybook({
      isSalesStage: isSalesStage,
      bobjectData: {
        company: company,
        activeBobject: mainBobject
      }
    }),
    activeBobjectSegmentationValues = _usePlaybook.activeBobjectSegmentationValues;
  var haveDefaultSegmentationLoaded = activeBobjectSegmentationValues && Object.keys(activeBobjectSegmentationValues).length;
  var headerText = !isSmartEmail ? 'Playbook' : hasSnippetsEnabled ? 'Templates & Snippets' : 'Playbook templates';
  useEffect(function () {
    if (haveDefaultSegmentationLoaded && isMainBobjectSalesStage === isSalesStage && !segmentationValues) {
      setFiltersContext({
        segmentationData: activeBobjectSegmentationValues,
        isSalesStage: isSalesStage,
        isFilterViewOpen: isFilterViewOpen,
        visibilityFilters: visibilityFilters,
        shouldShowBattlecards: [PlaybookTab$1.PITCHES, PlaybookTab$1.SNIPPETS].includes(selectedTab),
        shouldShowVisibilityFilters: selectedTab !== PlaybookTab$1.QQS
      });
    }
  }, [haveDefaultSegmentationLoaded]);
  var selectedValuesNames = useMemo(function () {
    if (!segmentationValues) {
      return [];
    }
    return Object.entries(segmentationValues).reduce(function (acc, _ref3) {
      var _ref4 = _slicedToArray$4(_ref3, 2),
        fieldId = _ref4[0],
        itemValues = _ref4[1];
      if ((itemValues === null || itemValues === void 0 ? void 0 : itemValues.length) === 0) return acc;
      var segmentationField = segmentationFields.find(function (segmentation) {
        return segmentation.id === fieldId;
      });
      if (!itemValues) return [].concat(_toConsumableArray(acc), ["All ".concat(segmentationField === null || segmentationField === void 0 ? void 0 : segmentationField.name, "s")]);
      var valuesNames = itemValues === null || itemValues === void 0 ? void 0 : itemValues.reduce(function (accField, itemValue) {
        var field = segmentationField === null || segmentationField === void 0 ? void 0 : segmentationField.values.find(function (segValue) {
          return segValue.id === itemValue;
        });
        if (field) return [].concat(_toConsumableArray(accField), [field === null || field === void 0 ? void 0 : field.name]);
        return accField;
      }, []);
      return [].concat(_toConsumableArray(acc), _toConsumableArray(valuesNames));
    }, []);
  }, [segmentationValues]);
  return /*#__PURE__*/jsxs("div", {
    className: styles$4.container,
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$4.header_container,
      children: [/*#__PURE__*/jsxs("div", {
        className: styles$4.headerTitle,
        style: isSmartEmail ? {
          marginBottom: '24px'
        } : undefined,
        children: [/*#__PURE__*/jsxs("span", {
          className: styles$4.title_container,
          children: [/*#__PURE__*/jsx(Icon, {
            name: "magic",
            size: 24,
            color: "purple"
          }), /*#__PURE__*/jsx(Text, {
            color: "purple",
            weight: "bold",
            children: headerText
          })]
        }), selectedTab !== PlaybookTab$1.QQS && /*#__PURE__*/jsx(TemplateSearch, {
          setSearchValue: setSearchValue,
          defaultOpen: isSmartEmail || sidePeekEnabled
        })]
      }), /*#__PURE__*/jsx("div", {
        className: styles$4.contentWrapper,
        children: /*#__PURE__*/jsx(Button, {
          size: "small",
          color: isFilterViewOpen ? 'purple' : 'lightPurple',
          uppercase: false,
          onClick: function onClick() {
            toggleFilterView(!isFilterViewOpen, selectedTab);
          },
          children: /*#__PURE__*/jsxs("div", {
            className: styles$4.buttonContent,
            children: [/*#__PURE__*/jsx("div", {
              className: styles$4.buttonText,
              children: (selectedValuesNames === null || selectedValuesNames === void 0 ? void 0 : selectedValuesNames.length) !== 0 ? /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsxs(Text, {
                  size: "xs",
                  color: "white",
                  weight: "bold",
                  className: styles$4.segmentedFor,
                  children: [selectedValuesNames.length, " filters:", ' ']
                }), /*#__PURE__*/jsx(Text, {
                  size: "xs",
                  color: "white",
                  className: styles$4.selectedValuesNames,
                  children: selectedValuesNames === null || selectedValuesNames === void 0 ? void 0 : selectedValuesNames.join(', ')
                })]
              }) : /*#__PURE__*/jsx(Text, {
                size: "xs",
                color: "white",
                weight: "bold",
                className: styles$4.segmentedFor,
                children: "Select segmentation criteria"
              })
            }), /*#__PURE__*/jsxs("div", {
              className: styles$4.buttonButtons,
              children: [/*#__PURE__*/jsx(Icon, {
                name: "sliders",
                color: "white",
                size: 16
              }), /*#__PURE__*/jsx(IconButton, {
                name: "cross",
                color: "white",
                size: 16,
                onClick: function onClick(e) {
                  e.stopPropagation();
                  setFiltersContext({
                    segmentationData: {},
                    isSalesStage: isSalesStage,
                    isFilterViewOpen: isFilterViewOpen
                  });
                }
              })]
            })]
          })
        })
      }), /*#__PURE__*/jsx(PlaybookTabs, {
        isSmartEmail: isSmartEmail,
        isDialer: isDialer,
        hasSnippetsEnabled: hasSnippetsEnabled,
        tabSelected: selectedTab,
        handleChangeTab: handleChangeTab,
        sidePeekEnabled: sidePeekEnabled
      })]
    }), segmentationFields ? /*#__PURE__*/jsx(TabContent, {
      isSmartEmail: isSmartEmail,
      onCardClicked: onCardClicked,
      tabSelected: selectedTab,
      activeBobject: mainBobject,
      refreshActiveBobject: function refreshActiveBobject() {
        return refreshMainBobject(mainBobject.id.typeName);
      },
      isSalesStage: isSalesStage,
      segmentationValues: segmentationValues,
      visibilityFilters: visibilityFilters,
      searchValue: searchValue,
      contextData: {
        leads: leads,
        company: company
      },
      templateFunctions: templateFunctions,
      actionsDisabled: actionsDisabled,
      sidePeekEnabled: sidePeekEnabled
    }) : /*#__PURE__*/jsx("div", {
      className: styles$4.spinner,
      children: /*#__PURE__*/jsx(Spinner, {
        name: "loadingCircle",
        color: "purple"
      })
    })]
  });
};

var css_248z$2 = ".templateDetail-module_separator__H0gUE {\n  margin: 8px 32px 12px 16px;\n  display: flex;\n  align-self: center;\n  width: 286px;\n  height: 1px;\n  background-color: var(--verySoftPeanut);\n}\n\n.templateDetail-module_container__NOMB9 {\n  padding: 0 24px;\n  height: 100%\n}\n\n.templateDetail-module_contentGeneralWrapper__GPPW7 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  max-height: 88%;\n}\n\n.templateDetail-module_header__YWhZ7 {\n  display: flex;\n  flex-direction: column;\n}\n\n.templateDetail-module_header__YWhZ7 > * {\n  margin-bottom: 12px;\n}\n\n.templateDetail-module_visibilityLabel__W53Hh {\n  display: flex;\n  align-items: center;\n}\n\n.templateDetail-module_headerIcons__ftXpH{\n  display: flex;\n  flex-direction: row;\n}\n\n.templateDetail-module_headerIcons__ftXpH > * {\n  margin-right: 10px;\n}\n\n.templateDetail-module_templateBody__eV4Sx {\n  overflow-y: scroll;\n  flex: 1;\n}\n\n.templateDetail-module_templateBody__eV4Sx ul, .templateDetail-module_templateBody__eV4Sx ol {\n  padding-left: 40px;\n}\n\n.templateDetail-module_templateBody__eV4Sx > ul * {\n  list-style: initial;\n}\n\n.templateDetail-module_templateBody__eV4Sx > ol * {\n  list-style: auto;\n}\n\n.templateDetail-module_statistics__nMdhH {\n  display: flex;\n  margin-top: 12px;\n}\n\n.templateDetail-module_loading__2d72W {\n  display: flex;\n  justify-content: center;\n  margin-top: 18px;\n}\n\n.templateDetail-module__lock__icon__CO3g3 {\n  margin-right: 4px;\n}\n\n.templateDetail-module_buttons__1Itkq{\n  display: flex;\n  padding-top: 24px;\n  padding-bottom: 10px;\n  box-sizing: border-box;\n  justify-content: space-between;\n  margin-left: -10px;\n}\n\n.templateDetail-module_dialerButtons__gXVqD {\n  display: flex;\n  padding-top: 9px;\n  padding-bottom: 10px;\n  box-sizing: border-box;\n  justify-content: space-between;\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.templateDetail-module_buttons_right__xsMDh{\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n}\n";
var styles$2 = {"separator":"templateDetail-module_separator__H0gUE","container":"templateDetail-module_container__NOMB9","contentGeneralWrapper":"templateDetail-module_contentGeneralWrapper__GPPW7","header":"templateDetail-module_header__YWhZ7","visibilityLabel":"templateDetail-module_visibilityLabel__W53Hh","headerIcons":"templateDetail-module_headerIcons__ftXpH","templateBody":"templateDetail-module_templateBody__eV4Sx","statistics":"templateDetail-module_statistics__nMdhH","loading":"templateDetail-module_loading__2d72W","_lock__icon":"templateDetail-module__lock__icon__CO3g3","buttons":"templateDetail-module_buttons__1Itkq","dialerButtons":"templateDetail-module_dialerButtons__gXVqD","buttons_right":"templateDetail-module_buttons_right__xsMDh"};
styleInject(css_248z$2);

var css_248z$1 = ".metric-module__statistics_item__cOVpO {\n  display: flex;\n}\n\n.metric-module__statistics_item__cOVpO > p {\n  cursor: default;\n  margin-left: 4px;\n  margin-right: 12px;\n}\n";
var styles$1 = {"_statistics_item":"metric-module__statistics_item__cOVpO"};
styleInject(css_248z$1);

var METRIC_INFO = {
  OPENED_RATE: {
    icon: 'eye',
    tooltip: 'Open rate'
  },
  CLICKED_RATE: {
    icon: 'cursorClickOutline',
    tooltip: 'Click rate'
  },
  REPLIED_RATE: {
    icon: 'reply',
    tooltip: 'Reply rate'
  },
  USED_COUNT: {
    icon: 'mailCompleted',
    tooltip: 'Times delivered'
  }
};
var Metric = function Metric(_ref) {
  var name = _ref.name,
    value = _ref.value;
  return /*#__PURE__*/jsx(Tooltip, {
    title: METRIC_INFO[name].tooltip,
    position: "bottom",
    children: /*#__PURE__*/jsxs("div", {
      className: styles$1._statistics_item,
      children: [/*#__PURE__*/jsx(Icon, {
        name: METRIC_INFO[name].icon,
        size: 18,
        color: "purple"
      }), /*#__PURE__*/jsx(Text, {
        size: "s",
        color: "purple",
        children: name.includes('RATE') ? Math.min(parseInt((value * 10).toString(), 10), 100) + '%' : value
      })]
    })
  });
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$3(); }
function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$3(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
var TemplateHeader = function TemplateHeader(_ref) {
  var name = _ref.name,
    updateDatetime = _ref.updateDatetime,
    isBattlecard = _ref.isBattlecard,
    visibility = _ref.visibility,
    createdBy = _ref.createdBy,
    type = _ref.type,
    cadenceUsages = _ref.cadenceUsages,
    templateStatistics = _ref.templateStatistics;
  var _ref2 = useUserSearch() || {},
    users = _ref2.users;
  var author = users === null || users === void 0 ? void 0 : users.find(function (user) {
    return user.id === createdBy;
  });
  return /*#__PURE__*/jsxs("div", {
    className: styles$2.header,
    children: [/*#__PURE__*/jsx(Text, {
      size: "m",
      weight: "bold",
      children: name
    }), /*#__PURE__*/jsxs(Text, {
      size: "s",
      color: "softPeanut",
      children: ["Last update:", ' ', formatDate(new Date(updateDatetime + (updateDatetime.slice(-1) === 'Z' ? '' : 'Z')), 'MMM dd, yyyy HH:mm (z)')]
    }), /*#__PURE__*/jsxs("div", {
      className: styles$2.headerIcons,
      children: [type === TEMPLATE_TYPES.EMAIL && cadenceUsages > 0 && /*#__PURE__*/jsxs(Label, {
        size: "small",
        color: "verySoftPurple",
        textColor: "purple",
        uppercase: false,
        overrideStyle: {
          maxWidth: '142px',
          letterSpacing: 0.5
        },
        children: ["Used in ", cadenceUsages, " cadences"]
      }), visibility && /*#__PURE__*/jsx(Label, {
        size: "small",
        color: "verySoftPurple",
        textColor: "purple",
        uppercase: false,
        overrideStyle: {
          maxWidth: '77px'
        },
        children: /*#__PURE__*/jsxs("span", {
          className: styles$2.visibilityLabel,
          children: [/*#__PURE__*/jsx(Icon, {
            name: visibility === 'PUBLIC' ? 'unlock' : 'lock',
            color: "purple",
            size: 16,
            className: styles$2._lock__icon
          }), visibility === 'PUBLIC' ? 'Public' : 'Private']
        })
      }), isBattlecard && /*#__PURE__*/jsx(Tooltip, {
        title: "Battlecard",
        position: "top",
        children: /*#__PURE__*/jsx(Icon, {
          name: "battlecards",
          color: "purple"
        })
      }), author && /*#__PURE__*/jsx(Tooltip, {
        title: "Author: ".concat(author === null || author === void 0 ? void 0 : author.name),
        position: "top",
        children: /*#__PURE__*/jsx(CircularBadge, {
          size: "s",
          color: "lightPeanut",
          style: {
            color: 'var(--white)',
            fontSize: '9px'
          },
          backgroundColor: (author === null || author === void 0 ? void 0 : author.color) || 'lightPeanut',
          children: (author === null || author === void 0 ? void 0 : author.shortname) || 'U'
        })
      })]
    }), type === TEMPLATE_TYPES.EMAIL && templateStatistics && Object.keys(templateStatistics).length !== 0 && /*#__PURE__*/jsxs("div", {
      className: styles$2.statistics,
      children: [/*#__PURE__*/jsx(Metric, {
        name: "USED_COUNT",
        value: templateStatistics.USED_COUNT
      }), /*#__PURE__*/jsx(Metric, {
        name: "OPENED_RATE",
        value: templateStatistics.OPENED_RATE
      }), /*#__PURE__*/jsx(Metric, {
        name: "CLICKED_RATE",
        value: templateStatistics.CLICKED_RATE
      }), /*#__PURE__*/jsx(Metric, {
        name: "REPLIED_RATE",
        value: templateStatistics.REPLIED_RATE
      })]
    })]
  });
};
var TemplateDetail = function TemplateDetail(_ref3) {
  var _clsx;
  var template = _ref3.template,
    extended = _ref3.extended,
    backButtonAction = _ref3.backButtonAction,
    dialerButtons = _ref3.dialerButtons,
    _ref3$insertButtonAct = _ref3.insertButtonAction,
    insertButtonAction = _ref3$insertButtonAct === void 0 ? function () {} : _ref3$insertButtonAct,
    _ref3$replaceButtonAc = _ref3.replaceButtonAction,
    replaceButtonAction = _ref3$replaceButtonAc === void 0 ? function () {} : _ref3$replaceButtonAc,
    setSelectedTemplate = _ref3.setSelectedTemplate;
  var _useState = useState(false),
    _useState2 = _slicedToArray$3(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var ref = useRef();
  var isSnippet = template.type === TEMPLATE_TYPES.SNIPPET;
  var _useMessagingTemplate = useMessagingTemplate(template === null || template === void 0 ? void 0 : template.id),
    deleteMessagingTemplate = _useMessagingTemplate.deleteMessagingTemplate;
  var isOwner = useIsTemplateOwner(template);
  var handleDelete = function handleDelete() {
    deleteMessagingTemplate(template === null || template === void 0 ? void 0 : template.id).then(function (res) {
      // @ts-ignore
      if (res.error) {
        console.error(res);
      } else {
        createToast({
          type: 'success',
          message: 'Template deleted successfully'
        });
      }
      setIsModalOpen(false);
      backButtonAction();
      window.dispatchEvent(new CustomEvent('PLAYBOOK_FEED'));
    });
  };
  return /*#__PURE__*/jsx("div", {
    className: styles$2.container,
    children: !template ? /*#__PURE__*/jsx("div", {
      className: styles$2.loading,
      children: /*#__PURE__*/jsx(Spinner, {
        name: "loadingCircle"
      })
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [extended && /*#__PURE__*/jsxs("div", {
        className: clsx((_clsx = {}, _defineProperty$4(_clsx, styles$2.buttons, !dialerButtons), _defineProperty$4(_clsx, styles$2.dialerButtons, !!dialerButtons), _clsx)),
        children: [/*#__PURE__*/jsx(Button, {
          iconLeft: "arrowLeft",
          size: "small",
          color: "purple",
          onClick: backButtonAction,
          variant: "clear",
          uppercase: false,
          children: "Back"
        }), !dialerButtons ? /*#__PURE__*/jsxs("div", {
          className: styles$2.buttons_right,
          children: [/*#__PURE__*/jsx(Tooltip, {
            title: isOwner ? 'Delete template' : 'Only the Owner or an Admin can delete this template',
            position: "top",
            children: /*#__PURE__*/jsx(Button, {
              iconLeft: "trashFull",
              size: "small",
              color: isOwner ? 'tomato' : 'softPeanut',
              variant: "secondary",
              onClick: function onClick() {
                return setIsModalOpen(true);
              },
              disabled: !isOwner
            })
          }), /*#__PURE__*/jsx(Tooltip, {
            title: isOwner ? 'Edit template' : 'Only the Owner or an Admin can edit this template',
            position: "top",
            children: /*#__PURE__*/jsx(Button, {
              iconLeft: "edit",
              size: "small",
              color: isOwner ? 'purple' : 'softPeanut',
              variant: "secondary",
              onClick: function onClick() {
                return setSelectedTemplate(_objectSpread$4(_objectSpread$4({}, template), {}, {
                  edit: true
                }));
              },
              disabled: !isOwner
            })
          }), !isSnippet && /*#__PURE__*/jsx(Tooltip, {
            title: "Insert template",
            position: "top",
            children: /*#__PURE__*/jsx(Button, {
              iconLeft: "fileInsert",
              size: "small",
              color: "purple",
              variant: "secondary",
              onClick: function onClick() {
                return insertButtonAction(template);
              }
            })
          }), /*#__PURE__*/jsx(Button, {
            iconLeft: isSnippet ? 'fileInsert' : 'sendEmailInvitation',
            size: "small",
            color: "purple",
            onClick: function onClick() {
              return isSnippet ? insertButtonAction(template) : replaceButtonAction(template);
            },
            variant: "primary",
            uppercase: false,
            children: isSnippet ? 'Insert' : 'Use'
          })]
        }) : /*#__PURE__*/jsx("div", {
          className: styles$2.buttons_right,
          children: dialerButtons
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: styles$2.contentGeneralWrapper,
        children: [/*#__PURE__*/jsx(TemplateHeader, _objectSpread$4({}, template)), /*#__PURE__*/jsx("div", {
          ref: ref,
          className: styles$2.templateBody,
          dangerouslySetInnerHTML: {
            __html: template === null || template === void 0 ? void 0 : template.previewContent
          }
        })]
      }), /*#__PURE__*/jsx(PlaybookConfirmationModal, {
        openMode: isModalOpen && 'Delete',
        templateId: template === null || template === void 0 ? void 0 : template.id,
        onClose: function onClose() {
          return setIsModalOpen(false);
        },
        onAccept: handleDelete
      })]
    })
  });
};

var css_248z = ".segmentationFilter-module_wrapper__MQwut {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.segmentationFilter-module_header__rZ7KM {\n  width: 100%;\n  padding: 8px 16px 8px 16px;\n}\n\n.segmentationFilter-module_smartHeader__9y8R3 {\n  padding: 0;\n}\n\n.segmentationFilter-module_segmentationHeader__wCrsN {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 8px 16px 16px 16px;\n}\n\n.segmentationFilter-module_smartSegmentationHeader__vzv65 {\n  padding: 0;\n  margin-bottom: 20px;\n}\n\n.segmentationFilter-module_filterGroup__N5BID {\n  display: flex;\n  width: 100%;\n  gap: 4px;\n  flex-wrap: wrap;\n  padding: 8px 16px 16px 16px;\n}\n\n.segmentationFilter-module_smartFilterGroup__zaJ-l {\n  padding: 16px 0;\n}\n\n.segmentationFilter-module_filterGroup__N5BID > div {\n  width: 48%;\n  margin-bottom: 4px;\n  font-size: 12px;\n}\n\n.segmentationFilter-module_stageSelector__810l7 {\n  align-self: center;\n  display: flex;\n  width: 302px;\n  height: 24px;\n  min-height: 24px;\n  border: var(--lightPurple) 1px solid;\n  border-radius: 4px;\n}\n\n.segmentationFilter-module_smartStageSelector__CBvQS {\n  width: 100%;\n}\n\n.segmentationFilter-module_label__ECsZh {\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: 151px;\n  display: flex;\n  color: var(--purple);\n  border-radius: 0 3px 3px 0;\n}\n\n.segmentationFilter-module_smartLabel__6Hxt9{\n  width: 50%;\n  height: 24px;\n}\n\n.segmentationFilter-module_label__ECsZh:not(:last-child) {\n  align-items: center;\n  cursor: pointer;\n  width: 50%;\n  color: var(--purple);\n  border-right: 1px var(--purple) solid;\n  border-radius: 3px 0 0 3px;\n}\n\n.segmentationFilter-module_selectedLabel__6jehk {\n  background-color: var(--purple);\n  color: var(--white);\n}\n\n.segmentationFilter-module_selectorsWrapper__bhLjE {\n  margin-top: 20px;\n  display: flex;\n  padding: 0 24px;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n}\n\n.segmentationFilter-module_smartSelectorsWrapper__ggJMf{\n  padding: 0 8px;\n  width: 100%;\n}\n\n.segmentationFilter-module_categoryBlock__hTpPz{\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.segmentationFilter-module_blockHeader__upw3G{\n display: flex;\n  justify-content: space-between;\n}\n\n.segmentationFilter-module_clearLabel__vk-cq{\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.segmentationFilter-module_clearLabel__vk-cq > p{\n  line-height: 14px;\n}\n\n.segmentationFilter-module_selectorMultiselect__jAtYV > div > div{\n  border: 1px solid var(--verySoftPeanut);\n  margin-bottom: 12px;\n}\n\n.segmentationFilter-module_selectorMultiselect__jAtYV > div > div > button > span{\n  color: var(--softPeanut) !important;\n}\n\n.segmentationFilter-module_activeFilterLabelWrapper__gD2IL{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.segmentationFilter-module_activeFilterLabelWrapperMask__9md4W{\n  overflow: hidden;\n}\n\n.segmentationFilter-module_filterLabel__glG2-{\n  max-width: 288px;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.segmentationFilter-module_filterLabel__glG2- > div{\n  display: flex;\n}\n\n.segmentationFilter-module_filterLabelText__73MY2{\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n";
var styles = {"wrapper":"segmentationFilter-module_wrapper__MQwut","header":"segmentationFilter-module_header__rZ7KM","smartHeader":"segmentationFilter-module_smartHeader__9y8R3","segmentationHeader":"segmentationFilter-module_segmentationHeader__wCrsN","smartSegmentationHeader":"segmentationFilter-module_smartSegmentationHeader__vzv65","filterGroup":"segmentationFilter-module_filterGroup__N5BID","smartFilterGroup":"segmentationFilter-module_smartFilterGroup__zaJ-l","stageSelector":"segmentationFilter-module_stageSelector__810l7","smartStageSelector":"segmentationFilter-module_smartStageSelector__CBvQS","label":"segmentationFilter-module_label__ECsZh","smartLabel":"segmentationFilter-module_smartLabel__6Hxt9","selectedLabel":"segmentationFilter-module_selectedLabel__6jehk","selectorsWrapper":"segmentationFilter-module_selectorsWrapper__bhLjE","smartSelectorsWrapper":"segmentationFilter-module_smartSelectorsWrapper__ggJMf","categoryBlock":"segmentationFilter-module_categoryBlock__hTpPz","blockHeader":"segmentationFilter-module_blockHeader__upw3G","clearLabel":"segmentationFilter-module_clearLabel__vk-cq","selectorMultiselect":"segmentationFilter-module_selectorMultiselect__jAtYV","activeFilterLabelWrapper":"segmentationFilter-module_activeFilterLabelWrapper__gD2IL","activeFilterLabelWrapperMask":"segmentationFilter-module_activeFilterLabelWrapperMask__9md4W","filterLabel":"segmentationFilter-module_filterLabel__glG2-","filterLabelText":"segmentationFilter-module_filterLabelText__73MY2"};
styleInject(css_248z);

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var SegmentationFiltersStages;
(function (SegmentationFiltersStages) {
  SegmentationFiltersStages["Prospecting"] = "Prospecting";
  SegmentationFiltersStages["Sales"] = "Sales";
})(SegmentationFiltersStages || (SegmentationFiltersStages = {}));
var SegmentationFilterContext = /*#__PURE__*/createContext(null);
var SegmentationFilterProvider = function SegmentationFilterProvider(_ref) {
  var children = _ref.children,
    filterValues = _ref.filterValues,
    shouldShowBattlecards = _ref.shouldShowBattlecards,
    shouldShowVisibilityFilters = _ref.shouldShowVisibilityFilters,
    isSalesStage = _ref.isSalesStage,
    setFiltersContext = _ref.setFiltersContext,
    visibilityFilters = _ref.visibilityFilters;
    _ref.defaultStage;
    var activeBobjectSegmentationValues = _ref.activeBobjectSegmentationValues,
    isSmartEmail = _ref.isSmartEmail;
  activeBobjectSegmentationValues && Object.keys(activeBobjectSegmentationValues).length > 0;
  function removeLabelValue(valueToRemove, segmentationField) {
    var filteredValues = filterValues[segmentationField.id].filter(function (value) {
      return value !== valueToRemove;
    });
    var newSegmentation = filteredValues && Object.keys(filterValues).reduce(function (acc, key) {
      var isFilteredKeyEmpty = key === segmentationField.id && filteredValues.length === 0;
      return _objectSpread$3(_objectSpread$3({}, acc), isFilteredKeyEmpty ? {} : _defineProperty$3({}, key, key === segmentationField.id ? filteredValues : filterValues[key]));
    }, {});
    setFiltersContext({
      segmentationData: newSegmentation,
      isSalesStage: isSalesStage,
      visibilityFilters: visibilityFilters,
      shouldShowBattlecards: shouldShowBattlecards,
      shouldShowVisibilityFilters: shouldShowVisibilityFilters
    });
  }
  function clearBlock(blockId) {
    var newValue = filterValues && Object.keys(filterValues).reduce(function (acc, key) {
      if (blockId !== key) {
        acc[key] = filterValues[key];
      } else {
        acc[key] = [];
      }
      return acc;
    }, {});
    setFiltersContext({
      segmentationData: newValue,
      isSalesStage: isSalesStage,
      visibilityFilters: visibilityFilters,
      shouldShowBattlecards: shouldShowBattlecards,
      shouldShowVisibilityFilters: shouldShowVisibilityFilters
    });
  }
  return /*#__PURE__*/jsx(SegmentationFilterContext.Provider, {
    value: {
      stageSelector: [isSalesStage ? SegmentationFiltersStages.Sales : SegmentationFiltersStages.Prospecting, function (value) {
        setFiltersContext({
          segmentationData: {},
          isSalesStage: value === SegmentationFiltersStages.Sales,
          visibilityFilters: visibilityFilters,
          shouldShowBattlecards: shouldShowBattlecards,
          shouldShowVisibilityFilters: shouldShowVisibilityFilters
        });
      }],
      selectedSegmentation: filterValues,
      setSelectedSegmentation: function setSelectedSegmentation(value) {
        setFiltersContext({
          segmentationData: value,
          isSalesStage: isSalesStage,
          shouldShowBattlecards: shouldShowBattlecards,
          visibilityFilters: visibilityFilters,
          shouldShowVisibilityFilters: shouldShowVisibilityFilters
        });
      },
      visibilityFilters: visibilityFilters,
      setVisibilityFilters: function setVisibilityFilters(value) {
        setFiltersContext({
          segmentationData: filterValues,
          isSalesStage: isSalesStage,
          shouldShowBattlecards: shouldShowBattlecards,
          shouldShowVisibilityFilters: shouldShowVisibilityFilters,
          visibilityFilters: _objectSpread$3(_objectSpread$3({}, visibilityFilters), value)
        });
      },
      removeLabelValue: removeLabelValue,
      clearBlock: clearBlock,
      isSmartEmail: isSmartEmail,
      shouldShowBattlecards: shouldShowBattlecards,
      shouldShowVisibilityFilters: shouldShowVisibilityFilters
    },
    children: children
  });
};
var useSegmentationFilter = function useSegmentationFilter() {
  var context = useContext(SegmentationFilterContext);
  if (context === undefined) {
    throw new Error('useInactiveHandlingModal must be used within the modal provider');
  }
  return context;
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2(); }
function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }
var StageLabel = function StageLabel(_ref) {
  var value = _ref.value,
    onClick = _ref.onClick,
    colorProps = _ref.colorProps,
    className = _ref.className;
  var icon = value === 'Prospecting' ? 'phone' : 'fileOpportunity';
  return /*#__PURE__*/jsxs("div", {
    onClick: onClick,
    className: className,
    children: [/*#__PURE__*/jsx(Icon, {
      name: icon,
      size: 16,
      color: colorProps
    }), /*#__PURE__*/jsx(Text, {
      size: "xs",
      color: colorProps,
      children: value
    })]
  });
};
var StageSelector = function StageSelector() {
  var _useSegmentationFilte = useSegmentationFilter(),
    _useSegmentationFilte2 = _slicedToArray$2(_useSegmentationFilte.stageSelector, 2),
    stage = _useSegmentationFilte2[0],
    setSelectedStage = _useSegmentationFilte2[1],
    isSmartEmail = _useSegmentationFilte.isSmartEmail;
  var getLabelProps = function getLabelProps(value) {
    var _clsx;
    var isSelected = value === stage;
    var className = clsx(styles.label, (_clsx = {}, _defineProperty$2(_clsx, styles.selectedLabel, isSelected), _defineProperty$2(_clsx, styles.smartLabel, isSmartEmail), _clsx));
    var colorProps = isSelected ? 'white' : 'purple';
    return {
      value: value,
      colorProps: colorProps,
      className: className,
      onClick: function onClick() {
        return setSelectedStage(value);
      }
    };
  };
  return /*#__PURE__*/jsx("div", {
    className: clsx(styles.stageSelector, _defineProperty$2({}, styles.smartStageSelector, isSmartEmail)),
    children: Object.keys(SegmentationFiltersStages).map(function (stage, index) {
      var props = getLabelProps(stage);
      return /*#__PURE__*/jsx(StageLabel, _objectSpread$2({}, props), "".concat(stage, "-").concat(index));
    })
  });
};

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }
function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
var ActiveFilterLabel = function ActiveFilterLabel(_ref) {
  var removeLabel = _ref.removeLabel,
    _ref$selectedValue = _ref.selectedValue,
    id = _ref$selectedValue.id,
    name = _ref$selectedValue.name;
  return /*#__PURE__*/jsx("div", {
    className: styles.filterLabel,
    children: /*#__PURE__*/jsxs(Label, {
      value: id,
      color: "verySoftPurple",
      uppercase: false,
      size: "small",
      children: [/*#__PURE__*/jsx(Text, {
        color: "purple",
        size: "xs",
        weight: "medium",
        className: styles.filterLabelText,
        children: name
      }), /*#__PURE__*/jsx(IconButton, {
        color: "peanut",
        name: "cross",
        onClick: removeLabel
      })]
    }, id)
  });
};
var ActiveFiltersLabelBlock = function ActiveFiltersLabelBlock(_ref2) {
  var segmentationField = _ref2.segmentationField,
    sectionValues = _ref2.sectionValues,
    selectedValues = _ref2.selectedValues;
  var _useState = useState(false),
    _useState2 = _slicedToArray$1(_useState, 2),
    showMore = _useState2[0],
    setShowMore = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray$1(_useState3, 2),
    elementHeight = _useState4[0],
    setElementHeight = _useState4[1];
  var _useSegmentationFilte = useSegmentationFilter(),
    removeLabelValue = _useSegmentationFilte.removeLabelValue;
  var getElementHeight = function getElementHeight() {
    var _document$getElementB;
    return (_document$getElementB = document.getElementById("filterBlockWapper".concat(segmentationField.id))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.offsetHeight;
  };
  useEffect(function () {
    setElementHeight(getElementHeight());
  }, [selectedValues.length]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("div", {
      className: styles.activeFilterLabelWrapperMask,
      style: {
        maxHeight: !showMore && '112px'
      },
      children: /*#__PURE__*/jsx("div", {
        className: styles.activeFilterLabelWrapper,
        id: "filterBlockWapper".concat(segmentationField.id),
        children: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(function (selectedValue) {
          var _sectionValues$find = sectionValues.find(function (value) {
              return value.id === selectedValue;
            }),
            id = _sectionValues$find.id,
            name = _sectionValues$find.name;
          return /*#__PURE__*/jsx(ActiveFilterLabel, {
            selectedValue: {
              id: id,
              name: name
            },
            removeLabel: function removeLabel() {
              return removeLabelValue(id, segmentationField);
            }
          }, id);
        })
      })
    }), !showMore && elementHeight > 112 && /*#__PURE__*/jsx(IconButton, {
      name: "more",
      color: "purple",
      onClick: function onClick() {
        setShowMore(!showMore);
      }
    })]
  });
};

var CategoryBlock = function CategoryBlock(_ref) {
  var _ref$segmentationFiel = _ref.segmentationField,
    sectionId = _ref$segmentationFiel.id,
    sectionName = _ref$segmentationFiel.name,
    sectionValues = _ref$segmentationFiel.values,
    selectedValues = _ref.selectedValues,
    segmentationField = _ref.segmentationField,
    onChange = _ref.onChange;
  var _useSegmentationFilte = useSegmentationFilter(),
    clearBlock = _useSegmentationFilte.clearBlock,
    isSmartEmail = _useSegmentationFilte.isSmartEmail;
  return /*#__PURE__*/jsxs("div", {
    className: styles.categoryBlock,
    children: [/*#__PURE__*/jsxs("div", {
      className: styles.blockHeader,
      children: [/*#__PURE__*/jsx(Text, {
        size: "xs",
        children: sectionName
      }), (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) > 0 && /*#__PURE__*/jsxs("div", {
        className: styles.clearLabel,
        onClick: function onClick() {
          clearBlock(sectionId);
        },
        children: [/*#__PURE__*/jsx(IconButton, {
          name: "cross",
          size: 14,
          color: "purple"
        }), /*#__PURE__*/jsx(Text, {
          size: "xxs",
          color: "purple",
          children: "clear"
        })]
      })]
    }), /*#__PURE__*/jsx("div", {
      className: styles.selectorMultiselect,
      children: /*#__PURE__*/jsx(MultiSelect, {
        size: "small",
        value: selectedValues ? selectedValues : [],
        width: isSmartEmail ? '356px' : '288px',
        renderDisplayValue: function renderDisplayValue() {
          return (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) === 0 || !selectedValues ? "Select ".concat(sectionName) : "".concat(selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length, " values selected");
        },
        onChange: onChange,
        selectAllOption: true,
        children: sectionValues.map(function (value) {
          return /*#__PURE__*/React.cloneElement( /*#__PURE__*/jsx(CheckItem, {
            value: value.id,
            children: value.name
          }, value.id), {
            checked: (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(value.id)) && false
          });
        })
      })
    }), (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) > 0 && /*#__PURE__*/jsx(ActiveFiltersLabelBlock, {
      segmentationField: segmentationField,
      selectedValues: selectedValues,
      sectionValues: sectionValues
    })]
  });
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var VisibilityFiltersGroup = function VisibilityFiltersGroup() {
  var _useSegmentationFilte = useSegmentationFilter(),
    visibilityFilters = _useSegmentationFilte.visibilityFilters,
    setVisibilityFilters = _useSegmentationFilte.setVisibilityFilters,
    isSmartEmail = _useSegmentationFilte.isSmartEmail,
    shouldShowBattlecards = _useSegmentationFilte.shouldShowBattlecards;
  return /*#__PURE__*/jsxs("div", {
    className: clsx(styles.filterGroup, _defineProperty$1({}, styles.smartFilterGroup, isSmartEmail)),
    children: [/*#__PURE__*/jsx(Checkbox, {
      size: "small",
      color: "purple",
      checked: visibilityFilters === null || visibilityFilters === void 0 ? void 0 : visibilityFilters.onlyMine,
      onClick: function onClick(value) {
        return setVisibilityFilters(_objectSpread$1(_objectSpread$1({}, visibilityFilters), {}, {
          onlyMine: value
        }));
      },
      children: "Only Mine"
    }), /*#__PURE__*/jsx(Checkbox, {
      size: "small",
      color: "purple",
      checked: visibilityFilters === null || visibilityFilters === void 0 ? void 0 : visibilityFilters.onlyPrivate,
      onClick: function onClick(value) {
        return setVisibilityFilters(_objectSpread$1(_objectSpread$1({}, visibilityFilters), {}, {
          onlyPrivate: value
        }));
      },
      children: "Only Private"
    }), /*#__PURE__*/jsx(Checkbox, {
      size: "small",
      color: "purple",
      checked: visibilityFilters === null || visibilityFilters === void 0 ? void 0 : visibilityFilters.onlyOfficial,
      onClick: function onClick(value) {
        return setVisibilityFilters(_objectSpread$1(_objectSpread$1({}, visibilityFilters), {}, {
          onlyOfficial: value
        }));
      },
      children: "Only Official"
    }), shouldShowBattlecards && /*#__PURE__*/jsx(Checkbox, {
      size: "small",
      color: "purple",
      checked: visibilityFilters === null || visibilityFilters === void 0 ? void 0 : visibilityFilters.onlyBattlecards,
      onClick: function onClick(value) {
        return setVisibilityFilters(_objectSpread$1(_objectSpread$1({}, visibilityFilters), {}, {
          onlyBattlecards: value
        }));
      },
      children: "Only Battlecards"
    })]
  });
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var withProvider = function withProvider(Component) {
  return function (_ref) {
    var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/jsx(SegmentationFilterProvider, _objectSpread(_objectSpread({}, props), {}, {
      children: /*#__PURE__*/jsx(Component, _objectSpread({}, props))
    }));
  };
};
var SegmentationFiltersView = function SegmentationFiltersView(_ref2) {
  var segmentationFields = _ref2.segmentationFields,
    isSalesEnabled = _ref2.isSalesEnabled;
  var _useSegmentationFilte = useSegmentationFilter(),
    selectedSegmentation = _useSegmentationFilte.selectedSegmentation,
    setSelectedSegmentation = _useSegmentationFilte.setSelectedSegmentation,
    isSmartEmail = _useSegmentationFilte.isSmartEmail,
    shouldShowVisibilityFilters = _useSegmentationFilte.shouldShowVisibilityFilters;
  return /*#__PURE__*/jsxs("div", {
    className: styles.wrapper,
    children: [shouldShowVisibilityFilters && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("div", {
        className: clsx(styles.header, _defineProperty({}, styles.smartHeader, isSmartEmail)),
        children: /*#__PURE__*/jsx(Text, {
          weight: "bold",
          children: "Segmentation and filters"
        })
      }), /*#__PURE__*/jsx(VisibilityFiltersGroup, {})]
    }), /*#__PURE__*/jsxs("div", {
      className: clsx(styles.segmentationHeader, _defineProperty({}, styles.smartSegmentationHeader, isSmartEmail)),
      children: [/*#__PURE__*/jsx(Text, {
        weight: "bold",
        size: shouldShowVisibilityFilters ? 's' : 'l',
        children: "Segmentation"
      }), /*#__PURE__*/jsx(IconButton, {
        name: "settings",
        color: "purple",
        onClick: function onClick() {
          return window.open("".concat(baseUrls$2["production"], "/app/playbook/messaging-segmentation"), '_blank');
        }
      })]
    }), isSalesEnabled && /*#__PURE__*/jsx(StageSelector, {}), /*#__PURE__*/jsx("div", {
      className: clsx(styles.selectorsWrapper, _defineProperty({}, styles.smartSelectorsWrapper, isSmartEmail)),
      children: segmentationFields === null || segmentationFields === void 0 ? void 0 : segmentationFields.map(function (segmentation) {
        return /*#__PURE__*/jsx(CategoryBlock, {
          segmentationField: segmentation,
          selectedValues: selectedSegmentation === null || selectedSegmentation === void 0 ? void 0 : selectedSegmentation[segmentation.id],
          onChange: function onChange(value) {
            return setSelectedSegmentation(_objectSpread(_objectSpread({}, selectedSegmentation), {}, _defineProperty({}, segmentation.id, value)));
          }
        }, segmentation.id);
      })
    })]
  });
};
var SegmentationFilter = withProvider(SegmentationFiltersView);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useSnippets = function useSnippets(bodyPlugins) {
  var _useSWR = useSWR('/messaging/messagingTemplates/snippets', function (url) {
      return api.get(url).then(function (_ref) {
        var data = _ref.data;
        return parseSnippets(data);
      });
    }, {
      revalidateOnFocus: true
    }),
    snippets = _useSWR.data,
    mutate = _useSWR.mutate;
  function parseSnippets(snippets) {
    if (!snippets) return [];
    return Object.entries(snippets).reduce(function (acc, _ref2) {
      var _ref3 = _slicedToArray(_ref2, 2);
        _ref3[0];
        var _ref3$ = _ref3[1],
        id = _ref3$.id,
        content = _ref3$.content,
        shortcut = _ref3$.shortcut,
        format = _ref3$.format;
      acc.push({
        key: id,
        text: shortcut,
        data: JSON.parse(JSON.stringify(deserialize(content, {
          format: format,
          plugins: bodyPlugins
        })))
      });
      return acc;
    }, []);
  }
  return {
    snippets: snippets,
    mutate: mutate
  };
};

export { HandleTemplate, PlaybookFeed, PlaybookTabElement, SegmentationFilter, TemplateDetail, baseUrls, getTemplateButtons, useSnippets };
